import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { SUPPORTED_LOCALES } from "./locales";
import { SIGNUP_PORTAL_TRANSLATIONS } from "../pages/public/signupPortal.copy";

const resources = {
  en: {
    translation: {
      appTitle: "Salon OS",
      login: "Login",
      logout: "Logout",
      language: "Language",
      dashboard: "Dashboard",
      calendar: "Calendar",
      clients: "Clients",
      staff: "Staff",
      services: "Services",
      inventory: "Inventory",
      automation: "Automation",
      integrations: "Integrations",
      analytics: "Analytics",
      settings: "Settings",
      loading: "Loading...",
      save: "Save",
      refresh: "Refresh",
      "manager.command": "Manager Command",
      "common.status": "Status",
      "nav.dashboard": "Dashboard",
      "nav.calendar": "Calendar",
      "nav.clients": "Clients",
      "nav.staff": "Staff",
      "nav.services": "Services",
      "nav.inventory": "Inventory",
      "nav.automation": "Automation",
      "nav.integrations": "Integrations",
      "nav.branding": "Branding",
      "nav.settings": "Settings",
      "locale.en": "English",
      "locale.ru": "Russian",
      "locale.es": "Spanish",
      "locale.de": "German",
      "locale.fa": "Persian",
      "manager.clients.intelligence": "Client Intelligence",
      "manager.clients.title": "Clients",
      "manager.clients.tab.active": "Active",
      "manager.clients.tab.archived": "Archived",
      "manager.clients.searchPlaceholder": "Search by name / phone / email",
      "manager.clients.filter.risk": "Risk",
      "manager.clients.filter.telegram": "Telegram",
      "manager.clients.filter.all": "All",
      "manager.clients.filter.linked": "Linked",
      "manager.clients.filter.unlinked": "Unlinked",
      "manager.clients.risk.minimal": "minimal",
      "manager.clients.risk.low": "low",
      "manager.clients.risk.medium": "medium",
      "manager.clients.risk.high": "high",
      "manager.clients.visibleCount": "{{count}} visible",
      "manager.clients.listTitle": "Client List",
      "manager.clients.noClients": "No clients found.",
      "manager.clients.addTitle": "Add Client",
      "manager.clients.conversationTitle": "Client Conversation",
      "manager.clients.selectHint": "Select a client to inspect risk and conversation history.",
      "manager.clients.notice.created": "Client created.",
      "manager.clients.notice.updated": "Client updated.",
      "manager.clients.notice.archived": "Client archived.",
      "manager.clients.notice.restored": "Client restored.",
      "manager.clients.notice.sent": "Message sent.",
      "manager.dashboard.ribbon.overline": "Manager Command Center",
      "manager.dashboard.ribbon.title": "Welcome back",
      "manager.dashboard.branchScope": "Branch scope",
      "manager.dashboard.allBranches": "All branches",
      "manager.dashboard.kpi.todayAppointments": "Today Appointments",
      "manager.dashboard.kpi.noShowRate": "No-show Rate",
      "manager.dashboard.kpi.queuePending": "Queue Pending",
      "manager.dashboard.kpi.lowStockAlerts": "Low Stock Alerts",
      "manager.dashboard.queueFailed24h": "{{count}} failed in 24h",
      "manager.dashboard.noQueueFailures24h": "No queue failures in 24h",
      "manager.dashboard.oldestPendingAge": "Oldest pending queue age: {{minutes}} min",
      "manager.dashboard.todayRhythm": "Today rhythm",
      "manager.dashboard.liveStatusMix": "Live booking status mix",
      "manager.dashboard.loadingRhythm": "Loading rhythm...",
      "manager.dashboard.status.pending": "Pending {{count}}",
      "manager.dashboard.status.confirmed": "Confirmed {{count}}",
      "manager.dashboard.status.completed": "Completed {{count}}",
      "manager.dashboard.status.cancelled": "Cancelled {{count}}",
      "manager.dashboard.status.noShow": "No-show {{count}}",
      "manager.dashboard.upcomingHighRisk": "Upcoming high-risk appointments",
      "manager.dashboard.defaultService": "Service",
      "manager.dashboard.withStaff": "with",
      "manager.dashboard.defaultStaff": "Staff",
      "manager.dashboard.noUpcomingHighRisk": "No upcoming high-risk appointments.",
      "manager.dashboard.recommendations": "Recommendations",
      "manager.dashboard.topStaff30d": "Top staff (30d)",
      "manager.dashboard.loadingStaff": "Loading staff performance...",
      "manager.dashboard.completed": "Completed: {{count}}",
      "manager.dashboard.noShowRate": "No-show rate: {{value}}%",
      "manager.dashboard.revenue": "Revenue: ${{value}}",
      "manager.dashboard.noStaffData": "No staff data yet.",
      "manager.dashboard.reco.noShow.title": "No-show trend is elevated",
      "manager.dashboard.reco.noShow.body": "Review high-risk clients and trigger reminder templates for tomorrow appointments.",
      "manager.dashboard.reco.messaging.title": "Messaging failures need attention",
      "manager.dashboard.reco.messaging.body": "{{count}} failed message(s) in the last 24h.",
      "manager.dashboard.reco.inventory.title": "Inventory risk detected",
      "manager.dashboard.reco.inventory.body": "{{count}} item(s) are at or below threshold.",
      "manager.dashboard.reco.upcoming.title": "Upcoming high-risk bookings",
      "manager.dashboard.reco.upcoming.body": "{{count}} upcoming appointment(s) are in high risk tier.",
      "manager.dashboard.reco.healthy.title": "Operations look healthy",
      "manager.dashboard.reco.healthy.body": "Queue, booking rhythm, and risk indicators are within normal range.",
      "manager.dashboard.reco.openClients": "Open Clients",
      "manager.dashboard.reco.openIntegrations": "Open Integrations",
      "manager.dashboard.reco.openInventory": "Open Inventory",
      "manager.dashboard.reco.openCalendar": "Open Calendar",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.active": "Active",
      "common.enabled": "enabled",
      "common.disabled": "disabled",
      "manager.layout.tenantFallback": "Tenant",
      "manager.layout.unknown": "unknown",
      "manager.media.selectFromLibrary": "Select from library",
      "manager.media.removePhoto": "Remove Photo",
      "manager.automation.title": "Automation",
      "manager.automation.section.rules": "Reminder Rules",
      "manager.automation.section.flags": "Feature Flags",
      "manager.automation.action.addRule": "Add Rule",
      "manager.automation.action.upsertFlag": "Upsert Flag",
      "manager.automation.currentLocale": "Current locale: {{locale}}",
      "manager.calendar.title": "Calendar Operations",
      "manager.calendar.subtitle": "Prioritize actions by risk, status, and schedule rhythm.",
      "manager.calendar.ribbon.overline": "Calendar Decision Mode",
      "manager.calendar.branch": "Branch",
      "manager.calendar.allBranches": "All branches",
      "manager.calendar.appointmentsTitle": "Appointments ({{day}})",
      "manager.calendar.itemsCount": "{{count}} item(s)",
      "manager.calendar.unknownClient": "Unknown client",
      "manager.calendar.defaultService": "Service",
      "manager.calendar.withStaff": "with",
      "manager.calendar.defaultStaff": "Staff",
      "manager.calendar.endsAt": "Ends {{time}}",
      "manager.calendar.riskPill": "risk: {{tier}}",
      "manager.calendar.noAppointments": "No appointments for this filter.",
      "manager.calendar.prompt.reschedule": "Enter new start time in ISO format (e.g. 2026-02-20T10:00:00Z)",
      "manager.calendar.status.all": "All statuses",
      "manager.calendar.status.pending_confirmation": "Pending confirmation",
      "manager.calendar.status.confirmed": "Confirmed",
      "manager.calendar.status.completed": "Completed",
      "manager.calendar.status.cancelled": "Cancelled",
      "manager.calendar.status.no_show": "No-show",
      "manager.calendar.action.confirm": "Confirm",
      "manager.calendar.action.cancel": "Cancel",
      "manager.calendar.action.complete": "Complete",
      "manager.calendar.action.no_show": "No-show",
      "manager.calendar.action.reschedule": "Reschedule",
      "manager.inventory.title": "Inventory",
      "manager.inventory.products": "Products",
      "manager.inventory.skuValue": "SKU {{sku}}",
      "manager.inventory.thresholdValue": "Low stock threshold {{count}}",
      "manager.inventory.createProduct": "Create Product",
      "manager.inventory.placeholder.sku": "SKU",
      "manager.inventory.placeholder.name": "Name",
      "manager.inventory.placeholder.locationName": "Location name",
      "manager.inventory.action.addProduct": "Add Product",
      "manager.inventory.stockLocations": "Stock Locations",
      "manager.inventory.action.addLocation": "Add Location",
      "manager.services.title": "Service Catalog",
      "manager.services.addService": "Add Service",
      "manager.services.placeholder.serviceName": "Service name",
      "manager.services.action.createService": "Create Service",
      "manager.staff.title": "Staff & Skills",
      "manager.staff.team": "Team",
      "manager.staff.unknownBranch": "Unknown branch",
      "manager.staff.skillsValue": "Skills: {{value}}",
      "manager.staff.none": "none",
      "manager.staff.addMember": "Add Staff Member",
      "manager.staff.placeholder.fullName": "Full name",
      "manager.staff.placeholder.skills": "skills comma-separated",
      "manager.staff.action.addStaff": "Add Staff",
      "manager.settings.title": "Settings",
      "manager.settings.tenantProfile": "Tenant Profile",
      "manager.settings.featureFlags": "Feature Flags",
      "manager.settings.field.name": "Name",
      "manager.settings.field.slug": "Slug",
      "manager.settings.field.status": "Status",
      "manager.settings.field.locale": "Locale",
      "manager.settings.field.plan": "Plan",
      "manager.settings.notSet": "not set",
      "manager.settings.messagingStrategy": "Messaging Strategy",
      "manager.settings.messagingStrategyHelp": "Configure Telegram-first or other channel-first behavior per tenant/market.",
      "manager.settings.field.marketProfile": "Market profile",
      "manager.settings.field.primaryMessenger": "Primary messenger",
      "manager.settings.field.messengerFirstMode": "Messenger-first mode",
      "manager.settings.marketProfile.default": "Default (mixed channels)",
      "manager.settings.marketProfile.telegram_first": "Telegram-first",
      "manager.settings.marketProfile.whatsapp_first": "WhatsApp-first",
      "manager.settings.primaryMessenger.none": "None",
      "manager.settings.primaryMessenger.telegram": "Telegram",
      "manager.settings.primaryMessenger.whatsapp": "WhatsApp",
      "manager.settings.primaryMessenger.sms": "SMS",
      "manager.settings.primaryMessenger.email": "Email",
      "manager.settings.saveStrategy": "Save Strategy",
      "manager.settings.saving": "Saving...",
      "manager.settings.strategySaved": "Messaging strategy saved.",
      "manager.settings.saveFailed": "Failed to save settings.",
      "manager.settings.channelCapabilities": "Channel Capabilities",
      "manager.settings.noCapabilities": "No channel capabilities available.",
      "manager.settings.cap.managerApp": "Manager embedded app",
      "manager.settings.cap.clientApp": "Client embedded app",
      "manager.settings.cap.freeformOutbound": "Free-form outbound",
      "manager.settings.cap.templateOnlyOutbound": "Template-only outbound",
      "manager.settings.cap.deepLinks": "Deep links",
      "manager.settings.cap.identityLinking": "Identity linking",
      "manager.integrations.title": "Integrations",
      "manager.integrations.activateBot": "Activate Telegram Bot",
      "manager.integrations.activateBotHelp": "Fresh installs need a Telegram integration with bot token. Paste token from BotFather, then save. This creates the integration if it does not exist, or updates existing one.",
      "manager.integrations.placeholder.integrationName": "Integration name",
      "manager.integrations.placeholder.botToken": "Telegram bot token (e.g. 123456:ABC...)",
      "manager.integrations.placeholder.chatId": "Your Telegram chat_id (e.g. 123456789)",
      "manager.integrations.placeholder.yourChatId": "Your chat_id: {{chatId}}",
      "manager.integrations.placeholder.recipientChatId": "Recipient chat_id",
      "manager.integrations.placeholder.messageText": "Message text",
      "manager.integrations.placeholder.template": "Write Telegram Markdown template here",
      "manager.integrations.defaultBotName": "Main Telegram Bot",
      "manager.integrations.saving": "Saving...",
      "manager.integrations.syncing": "Syncing...",
      "manager.integrations.sending": "Sending...",
      "manager.integrations.action.saveBot": "Save Telegram Bot",
      "manager.integrations.action.syncWebhook": "Sync Webhook",
      "manager.integrations.action.unlink": "Unlink",
      "manager.integrations.action.useMyChatId": "Use my chat_id",
      "manager.integrations.action.sendTest": "Send Test",
      "manager.integrations.action.saveTemplate": "Save Template",
      "manager.integrations.action.resetDefault": "Reset to Default",
      "manager.integrations.connectedChannels": "Connected Channels",
      "manager.integrations.linkTelegram": "Link Your Telegram",
      "manager.integrations.linkTelegramHelp1": "Enter your Telegram chat_id to receive booking notifications and use bot commands",
      "manager.integrations.linkTelegramHelp2": "To find your chat_id: open Telegram and message",
      "manager.integrations.linkTelegramHelp3": "- it will reply with your numeric ID.",
      "manager.integrations.currentlyLinked": "Currently linked:",
      "manager.integrations.sendTestMessage": "Send Test Message",
      "manager.integrations.sendTestHelp": "Send a test Telegram message to any chat_id to verify the integration works. Select a channel above first.",
      "manager.integrations.selectChannelToSend": "Select a channel above to enable sending.",
      "manager.integrations.noTelegramIntegrations": "No Telegram integrations found.",
      "manager.integrations.noResultYet": "No result yet.",
      "manager.integrations.bookingTemplateTitle": "Customer Booking Confirmation Template",
      "manager.integrations.bookingTemplateHelp": "Telegram supports Markdown in this template. Placeholders:",
      "manager.integrations.selectTelegramFirst": "Select a Telegram channel above first.",
      "manager.integrations.selectedNotTelegram": "Selected channel is not Telegram.",
      "manager.integrations.result.savedChatId": "Saved! Your Telegram chat_id: {{chatId}}",
      "manager.integrations.result.telegramActive": "Telegram integration is active: {{name}} ({{id}})",
      "manager.integrations.result.savedTemplate": "Saved booking confirmation template.",
      "manager.integrations.error.enterToken": "Enter Telegram bot token.",
      "manager.integrations.error.selectTelegramFirst": "Create or select a Telegram integration first.",
      "manager.integrations.cleared": "cleared",
      "manager.branding.title": "Branding Studio",
      "manager.branding.unsaved": "Unsaved changes",
      "manager.branding.saved": "Saved",
      "manager.branding.previewing": "Previewing {{mode}}",
      "manager.branding.previewMode.draft": "Draft preview",
      "manager.branding.previewMode.published": "Published preview",
      "manager.branding.action.saveDraft": "Save Draft",
      "manager.branding.action.publish": "Publish",
      "manager.branding.action.up": "Up",
      "manager.branding.action.down": "Down",
      "manager.branding.action.rollbackToDraft": "Rollback To Draft",
      "manager.branding.publishHint": "Publish includes unsaved local changes (draft is auto-saved first).",
      "manager.branding.panel.brandKit": "Brand Kit",
      "manager.branding.panel.layout": "Layout & Components",
      "manager.branding.panel.media": "Media Library",
      "manager.branding.panel.content": "Content",
      "manager.branding.panel.publish": "Preview & Publish",
      "manager.branding.panel.advanced": "Advanced",
      "manager.branding.pageSections": "Page Sections",
      "manager.branding.tokens": "Tokens",
      "manager.branding.baseSize": "Base size",
      "manager.branding.sectionInspector": "Section Inspector",
      "manager.branding.noSectionSelected": "No section selected",
      "manager.branding.sectionVariant": "Section variant",
      "manager.branding.default": "Default",
      "manager.branding.header": "Header",
      "manager.branding.alignLeft": "Align Left",
      "manager.branding.alignCenter": "Align Center",
      "manager.branding.compactPadding": "Compact Padding",
      "manager.branding.mediumPadding": "Medium Padding",
      "manager.branding.largePadding": "Large Padding",
      "manager.branding.list": "List",
      "manager.branding.grid": "Grid",
      "manager.branding.cardsWithImages": "Cards With Images",
      "manager.branding.imageCover": "Image Cover",
      "manager.branding.imageContain": "Image Contain",
      "manager.branding.showDuration": "Show duration",
      "manager.branding.showPrice": "Show price",
      "manager.branding.pills": "Pills",
      "manager.branding.cardsWithPhotos": "Cards With Photos",
      "manager.branding.showPhotos": "Show photos",
      "manager.branding.timeSlots": "Time Slots",
      "manager.branding.outline": "Outline",
      "manager.branding.filled": "Filled",
      "manager.branding.small": "Small",
      "manager.branding.medium": "Medium",
      "manager.branding.stepper": "Stepper",
      "manager.branding.numbers": "Numbers",
      "manager.branding.dots": "Dots",
      "manager.branding.showLabels": "Show labels",
      "manager.branding.form": "Form",
      "manager.branding.smallRadius": "Small Radius",
      "manager.branding.mediumRadius": "Medium Radius",
      "manager.branding.largeRadius": "Large Radius",
      "manager.branding.mediaLibrary": "Media Library",
      "manager.branding.heroMain": "Hero main: {{id}} | Aux photos: {{count}}",
      "manager.branding.mediaHint": "Filter by type to find assets faster. Main/Aux buttons update your draft.",
      "manager.branding.filter.all": "All",
      "manager.branding.filter.hero": "Hero",
      "manager.branding.filter.logo": "Logo",
      "manager.branding.filter.service": "Service",
      "manager.branding.filter.staff": "Staff",
      "manager.branding.search": "Search",
      "manager.branding.altText": "Alt text",
      "manager.branding.mainHeroSelected": "Main Hero (Draft Selected)",
      "manager.branding.setMainHero": "Set As Main Hero (Draft)",
      "manager.branding.removeAux": "Remove Aux",
      "manager.branding.addAux": "Add Aux",
      "manager.branding.publicContent": "Public Content",
      "manager.branding.placeholder.headerTitle": "Header title",
      "manager.branding.placeholder.headerSubtitle": "Header subtitle",
      "manager.branding.placeholder.beforeYouArrive": "Before you arrive",
      "manager.branding.versionHistory": "Version History",
      "manager.branding.placeholder.publishNotes": "Publish notes (optional)",
      "manager.branding.noNotes": "No notes",
      "manager.branding.accessibilitySafety": "Accessibility & Safety",
      "manager.branding.noWarnings": "No warnings.",
      "manager.branding.warning.contrastPrimary": "Low contrast: text on primary",
      "manager.branding.warning.contrastSurface": "Low contrast: text on surface",
      "manager.branding.warning.missingAlt": "{{count}} media item(s) missing alt text",
      "manager.branding.publishedVersion": "Published version: {{version}}",
      "manager.branding.draftUpdated": "Draft updated: {{value}}",
      "manager.clients.placeholder.fullName": "Full name",
      "manager.clients.placeholder.phone": "Phone",
      "manager.clients.placeholder.email": "Email",
      "manager.clients.placeholder.message": "Write a message using markdown: **bold**, *italic*, [link](https://...)",
      "manager.clients.noBranch": "No branch",
      "manager.clients.aria.editLocale": "Edit client locale",
      "manager.clients.aria.editBookingMode": "Edit client booking mode",
      "manager.clients.aria.newLocale": "New client locale",
      "manager.clients.aria.newBookingMode": "New client booking mode",
      "manager.clients.bookingMode.web_page": "Web page",
      "manager.clients.bookingMode.web_app": "Web app",
      "manager.clients.bookingMode.both": "Both",
      "manager.clients.noContact": "No contact details",
      "manager.clients.riskPill": "Risk {{tier}} ({{score}})",
      "manager.clients.telegram.linked": "Telegram linked",
      "manager.clients.telegram.unlinked": "Telegram not linked",
      "manager.clients.localePill": "Locale {{locale}}",
      "manager.clients.stats": "Visits {{visits}} | Completed {{completed}} | No-show {{noShow}}",
      "manager.clients.action.restore": "Restore",
      "manager.clients.action.archive": "Archive",
      "manager.clients.action.saveClient": "Save Client",
      "manager.clients.riskSummary": "Score: {{score}} | Tier: {{tier}}",
      "manager.clients.noFactors": "No factors available.",
      "manager.clients.loadingConversation": "Loading conversation...",
      "manager.clients.noHistory": "No history yet.",
      "manager.clients.sendMessage": "Send Message",
      "manager.clients.telegramLinkHint.before": "Telegram is not linked for this client. Ask them to send",
      "manager.clients.telegramLinkHint.andThen": "then",
      "manager.clients.telegramLinkHint.after": "to your bot. If they were linked before, you can still try sending and the server will attempt to recover chat ID from history.",
      "manager.clients.template.confirmReminder": "Confirm Reminder",
      "manager.clients.template.noShow": "No-show Follow-up",
      "manager.clients.template.reactivation": "Reactivation",
      "manager.clients.channel.telegram": "telegram",
      "manager.clients.channel.sms": "sms",
      "manager.clients.channel.email": "email",
      "manager.clients.attachment": "Attachment",
      "manager.clients.action.removeAttachment": "Remove attachment",
      "manager.clients.preview": "Preview",
      "manager.clients.action.send": "Send",
    },
  },
  fa: {
    translation: {
      appTitle: "Salon OS",
      login: "ورود",
      logout: "خروج",
      language: "زبان",
      dashboard: "داشبورد",
      calendar: "تقویم",
      clients: "مشتریان",
      staff: "کارکنان",
      services: "خدمات",
      inventory: "موجودی",
      automation: "اتوماسیون",
      integrations: "ادغام ها",
      analytics: "تحلیل ها",
      settings: "تنظیمات",
      loading: "در حال بارگذاری...",
      save: "ذخیره",
      refresh: "بروزرسانی",
      "manager.command": "فرمان مدیر",
      "common.status": "وضعیت",
      "nav.dashboard": "داشبورد",
      "nav.calendar": "تقویم",
      "nav.clients": "مشتریان",
      "nav.staff": "کارکنان",
      "nav.services": "خدمات",
      "nav.inventory": "موجودی",
      "nav.automation": "اتوماسیون",
      "nav.integrations": "ادغام ها",
      "nav.branding": "برندسازی",
      "nav.settings": "تنظیمات",
      "locale.en": "انگلیسی",
      "locale.ru": "روسی",
      "locale.es": "اسپانیایی",
      "locale.de": "آلمانی",
      "locale.fa": "فارسی",
      "manager.clients.intelligence": "هوش مشتری",
      "manager.clients.title": "مشتریان",
      "manager.clients.tab.active": "فعال",
      "manager.clients.tab.archived": "بایگانی شد",
      "manager.clients.searchPlaceholder": "جستجو بر اساس نام / تلفن / ایمیل",
      "manager.clients.filter.risk": "ریسک",
      "manager.clients.filter.telegram": "تلگرام",
      "manager.clients.filter.all": "همه",
      "manager.clients.filter.linked": "پیوند داده شده است",
      "manager.clients.filter.unlinked": "بدون پیوند",
      "manager.clients.risk.minimal": "حداقل",
      "manager.clients.risk.low": "پایین",
      "manager.clients.risk.medium": "متوسط",
      "manager.clients.risk.high": "بالا",
      "manager.clients.visibleCount": "{{count}} قابل مشاهده است",
      "manager.clients.listTitle": "لیست مشتریان",
      "manager.clients.noClients": "مشتری پیدا نشد",
      "manager.clients.addTitle": "مشتری اضافه کنید",
      "manager.clients.conversationTitle": "مکالمه مشتری",
      "manager.clients.selectHint": "مشتری را برای بررسی ریسک و سابقه مکالمه انتخاب کنید.",
      "manager.clients.notice.created": "مشتری ایجاد شد.",
      "manager.clients.notice.updated": "مشتری به روز شد.",
      "manager.clients.notice.archived": "مشتری بایگانی شد",
      "manager.clients.notice.restored": "مشتری بازیابی شد.",
      "manager.clients.notice.sent": "پیام ارسال شد.",
      "manager.dashboard.ribbon.overline": "مرکز فرماندهی مدیر",
      "manager.dashboard.ribbon.title": "خوش آمدید",
      "manager.dashboard.branchScope": "محدوده شعبه",
      "manager.dashboard.allBranches": "همه شعبه ها",
      "manager.dashboard.kpi.todayAppointments": "قرارهای امروز",
      "manager.dashboard.kpi.noShowRate": "نرخ عدم نمایش",
      "manager.dashboard.kpi.queuePending": "صف در انتظار",
      "manager.dashboard.kpi.lowStockAlerts": "هشدارهای سهام کم",
      "manager.dashboard.queueFailed24h": "{{count}} در 24 ساعت ناموفق بود",
      "manager.dashboard.noQueueFailures24h": "بدون شکست صف در 24 ساعت",
      "manager.dashboard.oldestPendingAge": "قدیمی ترین سن صف معلق: {{minutes}} دقیقه",
      "manager.dashboard.todayRhythm": "ریتم امروز",
      "manager.dashboard.liveStatusMix": "ترکیب وضعیت رزرو زنده",
      "manager.dashboard.loadingRhythm": "در حال بارگیری ریتم...",
      "manager.dashboard.status.pending": "در انتظار {{count}}",
      "manager.dashboard.status.confirmed": "تأیید {{count}}",
      "manager.dashboard.status.completed": "تکمیل شده {{count}}",
      "manager.dashboard.status.cancelled": "لغو {{count}}",
      "manager.dashboard.status.noShow": "عدم نمایش {{count}}",
      "manager.dashboard.upcomingHighRisk": "قرار ملاقات های پرخطر آینده",
      "manager.dashboard.defaultService": "خدمات",
      "manager.dashboard.withStaff": "با",
      "manager.dashboard.defaultStaff": "کارکنان",
      "manager.dashboard.noUpcomingHighRisk": "هیچ قرار ملاقات پرخطری در آینده وجود ندارد.",
      "manager.dashboard.recommendations": "توصیه ها",
      "manager.dashboard.topStaff30d": "کارکنان برتر (30 روز)",
      "manager.dashboard.loadingStaff": "بارگیری عملکرد کارکنان...",
      "manager.dashboard.completed": "تکمیل شده: {{count}}",
      "manager.dashboard.noShowRate": "نرخ عدم نمایش: {{value}}%",
      "manager.dashboard.revenue": "درآمد: ${{value}}",
      "manager.dashboard.noStaffData": "هنوز اطلاعاتی از کارکنان وجود ندارد.",
      "manager.dashboard.reco.noShow.title": "روند عدم نمایش افزایش یافته است",
      "manager.dashboard.reco.noShow.body": "مشتریان پرخطر را مرور کنید و الگوهای یادآوری را برای قرارهای فردا فعال کنید.",
      "manager.dashboard.reco.messaging.title": "خرابی های پیام رسانی نیاز به توجه دارند",
      "manager.dashboard.reco.messaging.body": "{{count}} پیام(های) ناموفق در 24 ساعت گذشته.",
      "manager.dashboard.reco.inventory.title": "ریسک موجودی شناسایی شد",
      "manager.dashboard.reco.inventory.body": "{{count}} مورد(های) در آستانه یا کمتر از آن هستند.",
      "manager.dashboard.reco.upcoming.title": "رزروهای پرخطر آینده",
      "manager.dashboard.reco.upcoming.body": "{{count}} قرار (های) آینده در ردیف پرخطر قرار دارند.",
      "manager.dashboard.reco.healthy.title": "عملیات سالم به نظر می رسد",
      "manager.dashboard.reco.healthy.body": "صف، ریتم رزرو و شاخص های ریسک در محدوده نرمال قرار دارند.",
      "manager.dashboard.reco.openClients": "مشتریان را باز کنید",
      "manager.dashboard.reco.openIntegrations": "ادغام ها را باز کنید",
      "manager.dashboard.reco.openInventory": "باز کردن موجودی",
      "manager.dashboard.reco.openCalendar": "تقویم را باز کنید",
      "common.save": "ذخیره",
      "common.cancel": "لغو",
      "common.edit": "ویرایش",
      "common.delete": "حذف",
      "common.active": "فعال",
      "common.enabled": "فعال",
      "common.disabled": "غیرفعال",
      "manager.layout.tenantFallback": "مستاجر",
      "manager.layout.unknown": "ناشناخته",
      "manager.media.selectFromLibrary": "از کتابخانه انتخاب کنید",
      "manager.media.removePhoto": "حذف عکس",
      "manager.automation.title": "اتوماسیون",
      "manager.automation.section.rules": "قوانین یادآوری",
      "manager.automation.section.flags": "پرچم های ویژگی",
      "manager.automation.action.addRule": "قانون اضافه کنید",
      "manager.automation.action.upsertFlag": "پرچم بالا",
      "manager.automation.currentLocale": "محل فعلی: {{locale}}",
      "manager.calendar.title": "عملیات تقویم",
      "manager.calendar.subtitle": "اقدامات را بر اساس ریسک، وضعیت و ریتم برنامه اولویت بندی کنید.",
      "manager.calendar.ribbon.overline": "حالت تصمیم گیری تقویم",
      "manager.calendar.branch": "شعبه",
      "manager.calendar.allBranches": "همه شعبه ها",
      "manager.calendar.appointmentsTitle": "قرار ملاقات ها ({{day}})",
      "manager.calendar.itemsCount": "{{count}} مورد(های)",
      "manager.calendar.unknownClient": "مشتری ناشناس",
      "manager.calendar.defaultService": "خدمات",
      "manager.calendar.withStaff": "با",
      "manager.calendar.defaultStaff": "کارکنان",
      "manager.calendar.endsAt": "پایان {{time}}",
      "manager.calendar.riskPill": "خطر: {{tier}}",
      "manager.calendar.noAppointments": "هیچ قرار ملاقاتی برای این فیلتر وجود ندارد.",
      "manager.calendar.prompt.reschedule": "زمان شروع جدید را در قالب ISO وارد کنید (به عنوان مثال 2026-02-20T10:00:00Z)",
      "manager.calendar.status.all": "همه وضعیت ها",
      "manager.calendar.status.pending_confirmation": "در انتظار تایید",
      "manager.calendar.status.confirmed": "تایید شد",
      "manager.calendar.status.completed": "تکمیل شد",
      "manager.calendar.status.cancelled": "لغو شد",
      "manager.calendar.status.no_show": "عدم نمایش",
      "manager.calendar.action.confirm": "تایید کنید",
      "manager.calendar.action.cancel": "لغو کنید",
      "manager.calendar.action.complete": "کامل",
      "manager.calendar.action.no_show": "عدم نمایش",
      "manager.calendar.action.reschedule": "زمان بندی مجدد",
      "manager.inventory.title": "موجودی",
      "manager.inventory.products": "محصولات",
      "manager.inventory.skuValue": "SKU {{sku}}",
      "manager.inventory.thresholdValue": "آستانه سهام پایین {{count}}",
      "manager.inventory.createProduct": "ایجاد محصول",
      "manager.inventory.placeholder.sku": "SKU",
      "manager.inventory.placeholder.name": "نام",
      "manager.inventory.placeholder.locationName": "نام مکان",
      "manager.inventory.action.addProduct": "افزودن محصول",
      "manager.inventory.stockLocations": "مکان های سهام",
      "manager.inventory.action.addLocation": "اضافه کردن مکان",
      "manager.services.title": "کاتالوگ خدمات",
      "manager.services.addService": "سرویس اضافه کنید",
      "manager.services.placeholder.serviceName": "نام سرویس",
      "manager.services.action.createService": "ایجاد سرویس",
      "manager.staff.title": "کارکنان و مهارت ها",
      "manager.staff.team": "تیم",
      "manager.staff.unknownBranch": "شاخه ناشناس",
      "manager.staff.skillsValue": "مهارت ها: {{value}}",
      "manager.staff.none": "هیچ کدام",
      "manager.staff.addMember": "عضو کارکنان را اضافه کنید",
      "manager.staff.placeholder.fullName": "نام کامل",
      "manager.staff.placeholder.skills": "مهارت ها با کاما از هم جدا شده اند",
      "manager.staff.action.addStaff": "کارمندان را اضافه کنید",
      "manager.settings.title": "تنظیمات",
      "manager.settings.tenantProfile": "مشخصات مستاجر",
      "manager.settings.featureFlags": "پرچم های ویژگی",
      "manager.settings.field.name": "نام",
      "manager.settings.field.slug": "حلزون حرکت کردن",
      "manager.settings.field.status": "وضعیت",
      "manager.settings.field.locale": "محلی",
      "manager.settings.field.plan": "برنامه ریزی کنید",
      "manager.settings.notSet": "تنظیم نشده است",
      "manager.settings.messagingStrategy": "استراتژی پیام رسانی",
      "manager.settings.messagingStrategyHelp": "پیکربندی Telegram-first یا سایر رفتارهای کانال اول برای هر مستاجر/market.",
      "manager.settings.field.marketProfile": "مشخصات بازار",
      "manager.settings.field.primaryMessenger": "پیام رسان اولیه",
      "manager.settings.field.messengerFirstMode": "حالت مسنجر اول",
      "manager.settings.marketProfile.default": "پیش‌فرض (کانال‌های ترکیبی)",
      "manager.settings.marketProfile.telegram_first": "تلگرام اول",
      "manager.settings.marketProfile.whatsapp_first": "واتس اپ-اول",
      "manager.settings.primaryMessenger.none": "هیچ کدام",
      "manager.settings.primaryMessenger.telegram": "تلگرام",
      "manager.settings.primaryMessenger.whatsapp": "واتس اپ",
      "manager.settings.primaryMessenger.sms": "اس ام اس",
      "manager.settings.primaryMessenger.email": "ایمیل",
      "manager.settings.saveStrategy": "ذخیره استراتژی",
      "manager.settings.saving": "در حال ذخیره...",
      "manager.settings.strategySaved": "استراتژی پیام‌رسانی ذخیره شد.",
      "manager.settings.saveFailed": "تنظیمات ذخیره نشد.",
      "manager.settings.channelCapabilities": "قابلیت های کانال",
      "manager.settings.noCapabilities": "هیچ قابلیت کانالی در دسترس نیست.",
      "manager.settings.cap.managerApp": "برنامه تعبیه شده مدیر",
      "manager.settings.cap.clientApp": "برنامه تعبیه شده مشتری",
      "manager.settings.cap.freeformOutbound": "فرم آزاد خروجی",
      "manager.settings.cap.templateOnlyOutbound": "خروجی فقط الگو",
      "manager.settings.cap.deepLinks": "پیوندهای عمیق",
      "manager.settings.cap.identityLinking": "پیوند هویت",
      "manager.integrations.title": "ادغام ها",
      "manager.integrations.activateBot": "ربات تلگرام را فعال کنید",
      "manager.integrations.activateBotHelp": "نصب های تازه نیاز به ادغام تلگرام با توکن ربات دارند. توکن را از BotFather بچسبانید، سپس ذخیره کنید. این یکپارچه سازی را در صورت عدم وجود ایجاد می کند یا موجود را به روز می کند.",
      "manager.integrations.placeholder.integrationName": "نام ادغام",
      "manager.integrations.placeholder.botToken": "توکن ربات تلگرام (به عنوان مثال 123456:ABC...)",
      "manager.integrations.placeholder.chatId": "chat_id تلگرام شما (به عنوان مثال 123456789)",
      "manager.integrations.placeholder.yourChatId": "chat_id شما: {{chatId}}",
      "manager.integrations.placeholder.recipientChatId": "chat_id گیرنده",
      "manager.integrations.placeholder.messageText": "متن پیام",
      "manager.integrations.placeholder.template": "قالب تلگرام Markdown را اینجا بنویسید",
      "manager.integrations.defaultBotName": "ربات اصلی تلگرام",
      "manager.integrations.saving": "در حال ذخیره...",
      "manager.integrations.syncing": "در حال همگام سازی...",
      "manager.integrations.sending": "ارسال...",
      "manager.integrations.action.saveBot": "ذخیره ربات تلگرام",
      "manager.integrations.action.syncWebhook": "همگام سازی وب هوک",
      "manager.integrations.action.unlink": "لغو پیوند",
      "manager.integrations.action.useMyChatId": "از chat_id من استفاده کنید",
      "manager.integrations.action.sendTest": "ارسال تست",
      "manager.integrations.action.saveTemplate": "ذخیره الگو",
      "manager.integrations.action.resetDefault": "بازنشانی به حالت پیش فرض",
      "manager.integrations.connectedChannels": "کانال های متصل",
      "manager.integrations.linkTelegram": "تلگرام خود را لینک کنید",
      "manager.integrations.linkTelegramHelp1": "برای دریافت نوتیفیکیشن رزرو و استفاده از دستورات ربات، chat_id تلگرام خود را وارد کنید",
      "manager.integrations.linkTelegramHelp2": "برای پیدا کردن chat_id خود: تلگرام را باز کنید و پیام دهید",
      "manager.integrations.linkTelegramHelp3": "- با شناسه عددی شما پاسخ خواهد داد.",
      "manager.integrations.currentlyLinked": "در حال حاضر پیوند داده شده است:",
      "manager.integrations.sendTestMessage": "ارسال پیام آزمایشی",
      "manager.integrations.sendTestHelp": "یک پیام آزمایشی تلگرام به هر chat_id بفرستید تا عملکرد یکپارچه سازی را تأیید کنید. ابتدا یک کانال بالا را انتخاب کنید.",
      "manager.integrations.selectChannelToSend": "یک کانال بالا را برای فعال کردن ارسال انتخاب کنید.",
      "manager.integrations.noTelegramIntegrations": "هیچ ادغام تلگرام پیدا نشد.",
      "manager.integrations.noResultYet": "هنوز نتیجه ای نگرفته",
      "manager.integrations.bookingTemplateTitle": "الگوی تایید رزرو مشتری",
      "manager.integrations.bookingTemplateHelp": "تلگرام در این قالب از Markdown پشتیبانی می کند. مکان‌داران:",
      "manager.integrations.selectTelegramFirst": "ابتدا یک کانال تلگرامی بالا را انتخاب کنید.",
      "manager.integrations.selectedNotTelegram": "کانال انتخابی تلگرام نیست.",
      "manager.integrations.result.savedChatId": "ذخیره شد! chat_id تلگرام شما: {{chatId}}",
      "manager.integrations.result.telegramActive": "ادغام تلگرام فعال است: {{name}} ({{id}})",
      "manager.integrations.result.savedTemplate": "الگوی تایید رزرو ذخیره شده",
      "manager.integrations.error.enterToken": "توکن ربات تلگرام را وارد کنید.",
      "manager.integrations.error.selectTelegramFirst": "ابتدا یک ادغام تلگرام ایجاد یا انتخاب کنید.",
      "manager.integrations.cleared": "پاک شد",
      "manager.branding.title": "استودیو برندسازی",
      "manager.branding.unsaved": "تغییرات ذخیره نشده",
      "manager.branding.saved": "ذخیره شد",
      "manager.branding.previewing": "در حال پیش نمایش {{mode}}",
      "manager.branding.previewMode.draft": "پیش نمایش پیش نویس",
      "manager.branding.previewMode.published": "پیش نمایش منتشر شده",
      "manager.branding.action.saveDraft": "ذخیره پیش نویس",
      "manager.branding.action.publish": "منتشر کنید",
      "manager.branding.action.up": "بالا",
      "manager.branding.action.down": "پایین",
      "manager.branding.action.rollbackToDraft": "بازگشت به پیش نویس",
      "manager.branding.publishHint": "انتشار شامل تغییرات محلی ذخیره نشده است (پیش نویس ابتدا به صورت خودکار ذخیره می شود).",
      "manager.branding.panel.brandKit": "کیت برند",
      "manager.branding.panel.layout": "چیدمان و اجزاء",
      "manager.branding.panel.media": "کتابخانه رسانه",
      "manager.branding.panel.content": "محتوا",
      "manager.branding.panel.publish": "پیش نمایش و انتشار",
      "manager.branding.panel.advanced": "پیشرفته",
      "manager.branding.pageSections": "بخش های صفحه",
      "manager.branding.tokens": "توکن ها",
      "manager.branding.baseSize": "اندازه پایه",
      "manager.branding.sectionInspector": "بازرس بخش",
      "manager.branding.noSectionSelected": "هیچ بخشی انتخاب نشده است",
      "manager.branding.sectionVariant": "نوع بخش",
      "manager.branding.default": "پیش فرض",
      "manager.branding.header": "سربرگ",
      "manager.branding.alignLeft": "تراز چپ",
      "manager.branding.alignCenter": "تراز کردن مرکز",
      "manager.branding.compactPadding": "بالشتک فشرده",
      "manager.branding.mediumPadding": "بالشتک متوسط",
      "manager.branding.largePadding": "بالشتک بزرگ",
      "manager.branding.list": "فهرست کنید",
      "manager.branding.grid": "شبکه",
      "manager.branding.cardsWithImages": "کارت با تصاویر",
      "manager.branding.imageCover": "جلد تصویر",
      "manager.branding.imageContain": "حاوی تصویر",
      "manager.branding.showDuration": "نمایش مدت زمان",
      "manager.branding.showPrice": "نمایش قیمت",
      "manager.branding.pills": "قرص",
      "manager.branding.cardsWithPhotos": "کارت با عکس",
      "manager.branding.showPhotos": "نمایش عکس ها",
      "manager.branding.timeSlots": "زمان اسلات",
      "manager.branding.outline": "طرح کلی",
      "manager.branding.filled": "پر شده است",
      "manager.branding.small": "کوچک",
      "manager.branding.medium": "متوسط",
      "manager.branding.stepper": "استپر",
      "manager.branding.numbers": "اعداد",
      "manager.branding.dots": "نقطه ها",
      "manager.branding.showLabels": "نشان دادن برچسب ها",
      "manager.branding.form": "فرم",
      "manager.branding.smallRadius": "شعاع کوچک",
      "manager.branding.mediumRadius": "شعاع متوسط",
      "manager.branding.largeRadius": "شعاع بزرگ",
      "manager.branding.mediaLibrary": "کتابخانه رسانه",
      "manager.branding.heroMain": "قهرمان اصلی: {{id}} | عکس‌های کمکی: {{count}}",
      "manager.branding.mediaHint": "بر اساس نوع فیلتر کنید تا دارایی ها را سریعتر پیدا کنید. دکمه های اصلی/Aux پیش نویس شما را به روز می کنند.",
      "manager.branding.filter.all": "همه",
      "manager.branding.filter.hero": "قهرمان",
      "manager.branding.filter.logo": "لوگو",
      "manager.branding.filter.service": "خدمات",
      "manager.branding.filter.staff": "کارکنان",
      "manager.branding.search": "جستجو کنید",
      "manager.branding.altText": "متن جایگزین",
      "manager.branding.mainHeroSelected": "قهرمان اصلی (پیش نویس انتخاب شده)",
      "manager.branding.setMainHero": "تنظیم به عنوان قهرمان اصلی (پیش نویس)",
      "manager.branding.removeAux": "Aux را حذف کنید",
      "manager.branding.addAux": "افزودن Aux",
      "manager.branding.publicContent": "محتوای عمومی",
      "manager.branding.placeholder.headerTitle": "عنوان سربرگ",
      "manager.branding.placeholder.headerSubtitle": "زیرنویس هدر",
      "manager.branding.placeholder.beforeYouArrive": "قبل از اینکه برسید",
      "manager.branding.versionHistory": "تاریخچه نسخه",
      "manager.branding.placeholder.publishNotes": "انتشار یادداشت ها (اختیاری)",
      "manager.branding.noNotes": "بدون یادداشت",
      "manager.branding.accessibilitySafety": "دسترسی و ایمنی",
      "manager.branding.noWarnings": "بدون هشدار",
      "manager.branding.warning.contrastPrimary": "کنتراست کم: متن روی اولیه",
      "manager.branding.warning.contrastSurface": "کنتراست کم: متن روی سطح",
      "manager.branding.warning.missingAlt": "{{count}} مورد(های) رسانه فاقد متن جایگزین است",
      "manager.branding.publishedVersion": "نسخه منتشر شده: {{version}}",
      "manager.branding.draftUpdated": "پیش نویس به روز شد: {{value}}",
      "manager.clients.placeholder.fullName": "نام کامل",
      "manager.clients.placeholder.phone": "تلفن",
      "manager.clients.placeholder.email": "ایمیل",
      "manager.clients.placeholder.message": "با استفاده از علامت گذاری پیام بنویسید: **پررنگ**، *مورب*، [پیوند](https://...)",
      "manager.clients.noBranch": "بدون شعبه",
      "manager.clients.aria.editLocale": "ویرایش محلی مشتری",
      "manager.clients.aria.editBookingMode": "حالت رزرو مشتری را ویرایش کنید",
      "manager.clients.aria.newLocale": "محلی مشتری جدید",
      "manager.clients.aria.newBookingMode": "حالت رزرو مشتری جدید",
      "manager.clients.bookingMode.web_page": "صفحه وب",
      "manager.clients.bookingMode.web_app": "برنامه وب",
      "manager.clients.bookingMode.both": "هر دو",
      "manager.clients.noContact": "جزئیات تماس وجود ندارد",
      "manager.clients.riskPill": "خطر {{tier}} ({{score}})",
      "manager.clients.telegram.linked": "تلگرام لینک شد",
      "manager.clients.telegram.unlinked": "تلگرام لینک نیست",
      "manager.clients.localePill": "منطقه {{locale}}",
      "manager.clients.stats": "بازدیدهای {{visits}} | تکمیل شده {{completed}} | عدم نمایش {{noShow}}",
      "manager.clients.action.restore": "بازیابی کنید",
      "manager.clients.action.archive": "آرشیو",
      "manager.clients.action.saveClient": "ذخیره مشتری",
      "manager.clients.riskSummary": "امتیاز: {{score}} | ردیف: {{tier}}",
      "manager.clients.noFactors": "فاکتوری در دسترس نیست",
      "manager.clients.loadingConversation": "در حال بارگیری مکالمه...",
      "manager.clients.noHistory": "هنوز سابقه ندارد.",
      "manager.clients.sendMessage": "ارسال پیام",
      "manager.clients.telegramLinkHint.before": "تلگرام برای این مشتری لینک نشده است. از آنها بخواهید بفرستند",
      "manager.clients.telegramLinkHint.andThen": "سپس",
      "manager.clients.telegramLinkHint.after": "به ربات شما اگر قبلاً پیوند داده شده بودند، همچنان می‌توانید ارسال را امتحان کنید و سرور تلاش می‌کند شناسه چت را از سابقه بازیابی کند.",
      "manager.clients.template.confirmReminder": "یادآوری را تأیید کنید",
      "manager.clients.template.noShow": "عدم نمایش پیگیری",
      "manager.clients.template.reactivation": "فعال سازی مجدد",
      "manager.clients.channel.telegram": "تلگرام",
      "manager.clients.channel.sms": "اس ام اس",
      "manager.clients.channel.email": "ایمیل",
      "manager.clients.attachment": "پیوست",
      "manager.clients.action.removeAttachment": "حذف پیوست",
      "manager.clients.preview": "پیش نمایش",
      "manager.clients.action.send": "ارسال کنید",
    },
  },
  de: {
    translation: {
      appTitle: "Salon-Betriebssystem",
      login: "Anmelden",
      logout: "Abmelden",
      language: "Sprache",
      dashboard: "Dashboard",
      calendar: "Kalender",
      clients: "Kunden",
      staff: "Mitarbeiter",
      services: "Leistungen",
      inventory: "Inventar",
      automation: "Automatisierung",
      integrations: "Integrationen",
      analytics: "Analysen",
      settings: "Einstellungen",
      loading: "Wird geladen...",
      save: "Speichern",
      refresh: "Aktualisieren",
      "manager.command": "Manager-Befehl",
      "common.status": "Status",
      "nav.dashboard": "Armaturenbrett",
      "nav.calendar": "Kalender",
      "nav.clients": "Kunden",
      "nav.staff": "Personal",
      "nav.services": "Dienstleistungen",
      "nav.inventory": "Inventar",
      "nav.automation": "Automatisierung",
      "nav.integrations": "Integrationen",
      "nav.branding": "Branding",
      "nav.settings": "Einstellungen",
      "locale.en": "Englisch",
      "locale.ru": "Russisch",
      "locale.es": "Spanisch",
      "locale.de": "Deutsch",
      "locale.fa": "persisch",
      "manager.clients.intelligence": "Kundenintelligenz",
      "manager.clients.title": "Kunden",
      "manager.clients.tab.active": "Aktiv",
      "manager.clients.tab.archived": "Archiviert",
      "manager.clients.searchPlaceholder": "Suche nach Name / Telefon / E-Mail",
      "manager.clients.filter.risk": "Risiko",
      "manager.clients.filter.telegram": "Telegramm",
      "manager.clients.filter.all": "Alle",
      "manager.clients.filter.linked": "Verlinkt",
      "manager.clients.filter.unlinked": "Nicht verknüpft",
      "manager.clients.risk.minimal": "minimal",
      "manager.clients.risk.low": "niedrig",
      "manager.clients.risk.medium": "Medium",
      "manager.clients.risk.high": "hoch",
      "manager.clients.visibleCount": "{{count}} sichtbar",
      "manager.clients.listTitle": "Kundenliste",
      "manager.clients.noClients": "Keine Kunden gefunden.",
      "manager.clients.addTitle": "Client hinzufügen",
      "manager.clients.conversationTitle": "Kundengespräch",
      "manager.clients.selectHint": "Wählen Sie einen Kunden aus, um das Risiko und den Gesprächsverlauf zu überprüfen.",
      "manager.clients.notice.created": "Kunde erstellt.",
      "manager.clients.notice.updated": "Client aktualisiert.",
      "manager.clients.notice.archived": "Kunde archiviert.",
      "manager.clients.notice.restored": "Client wiederhergestellt.",
      "manager.clients.notice.sent": "Nachricht gesendet.",
      "manager.dashboard.ribbon.overline": "Manager-Kommandozentrale",
      "manager.dashboard.ribbon.title": "Willkommen zurück",
      "manager.dashboard.branchScope": "Zweigbereich",
      "manager.dashboard.allBranches": "Alle Filialen",
      "manager.dashboard.kpi.todayAppointments": "Heute Termine",
      "manager.dashboard.kpi.noShowRate": "No-Show-Rate",
      "manager.dashboard.kpi.queuePending": "Warteschlange ausstehend",
      "manager.dashboard.kpi.lowStockAlerts": "Warnungen bei niedrigem Lagerbestand",
      "manager.dashboard.queueFailed24h": "{{count}} ist innerhalb von 24 Stunden fehlgeschlagen",
      "manager.dashboard.noQueueFailures24h": "Keine Warteschlangenfehler innerhalb von 24 Stunden",
      "manager.dashboard.oldestPendingAge": "Alter der ältesten ausstehenden Warteschlange: {{minutes}} Min",
      "manager.dashboard.todayRhythm": "Heute Rhythmus",
      "manager.dashboard.liveStatusMix": "Live-Buchungsstatus-Mix",
      "manager.dashboard.loadingRhythm": "Laderhythmus...",
      "manager.dashboard.status.pending": "Ausstehend {{count}}",
      "manager.dashboard.status.confirmed": "Bestätigt {{count}}",
      "manager.dashboard.status.completed": "Abgeschlossen {{count}}",
      "manager.dashboard.status.cancelled": "Abgebrochen {{count}}",
      "manager.dashboard.status.noShow": "Nichterscheinen {{count}}",
      "manager.dashboard.upcomingHighRisk": "Bevorstehende Termine mit hohem Risiko",
      "manager.dashboard.defaultService": "Leistung",
      "manager.dashboard.withStaff": "mit",
      "manager.dashboard.defaultStaff": "Personal",
      "manager.dashboard.noUpcomingHighRisk": "Keine bevorstehenden Termine mit hohem Risiko.",
      "manager.dashboard.recommendations": "Empfehlungen",
      "manager.dashboard.topStaff30d": "Spitzenpersonal (30 Tage)",
      "manager.dashboard.loadingStaff": "Mitarbeiterleistung wird geladen...",
      "manager.dashboard.completed": "Abgeschlossen: {{count}}",
      "manager.dashboard.noShowRate": "No-Show-Rate: {{value}} %",
      "manager.dashboard.revenue": "Umsatz: ${{value}}",
      "manager.dashboard.noStaffData": "Noch keine Personaldaten.",
      "manager.dashboard.reco.noShow.title": "Der No-Show-Trend ist erhöht",
      "manager.dashboard.reco.noShow.body": "Überprüfen Sie Kunden mit hohem Risiko und erstellen Sie Erinnerungsvorlagen für morgige Termine.",
      "manager.dashboard.reco.messaging.title": "Messaging-Fehler erfordern Aufmerksamkeit",
      "manager.dashboard.reco.messaging.body": "{{count}} fehlgeschlagene Nachricht(en) in den letzten 24 Stunden.",
      "manager.dashboard.reco.inventory.title": "Bestandsrisiko erkannt",
      "manager.dashboard.reco.inventory.body": "{{count}} Artikel liegen am oder unter dem Schwellenwert.",
      "manager.dashboard.reco.upcoming.title": "Bevorstehende Buchungen mit hohem Risiko",
      "manager.dashboard.reco.upcoming.body": "{{count}} bevorstehende(n) Termin(e) liegen in der Hochrisikostufe.",
      "manager.dashboard.reco.healthy.title": "Der Betrieb sieht gesund aus",
      "manager.dashboard.reco.healthy.body": "Warteschlange, Buchungsrhythmus und Risikoindikatoren liegen im normalen Bereich.",
      "manager.dashboard.reco.openClients": "Offene Kunden",
      "manager.dashboard.reco.openIntegrations": "Offene Integrationen",
      "manager.dashboard.reco.openInventory": "Inventar öffnen",
      "manager.dashboard.reco.openCalendar": "Kalender öffnen",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.edit": "Bearbeiten",
      "common.delete": "Löschen",
      "common.active": "Aktiv",
      "common.enabled": "aktiviert",
      "common.disabled": "deaktiviert",
      "manager.layout.tenantFallback": "Mieter",
      "manager.layout.unknown": "unbekannt",
      "manager.media.selectFromLibrary": "Aus der Bibliothek auswählen",
      "manager.media.removePhoto": "Foto entfernen",
      "manager.automation.title": "Automatisierung",
      "manager.automation.section.rules": "Erinnerungsregeln",
      "manager.automation.section.flags": "Feature-Flags",
      "manager.automation.action.addRule": "Regel hinzufügen",
      "manager.automation.action.upsertFlag": "Upsert-Flagge",
      "manager.automation.currentLocale": "Aktueller Standort: {{locale}}",
      "manager.calendar.title": "Kalenderoperationen",
      "manager.calendar.subtitle": "Priorisieren Sie Aktionen nach Risiko, Status und Zeitplanrhythmus.",
      "manager.calendar.ribbon.overline": "Kalenderentscheidungsmodus",
      "manager.calendar.branch": "Zweig",
      "manager.calendar.allBranches": "Alle Filialen",
      "manager.calendar.appointmentsTitle": "Termine ({{day}})",
      "manager.calendar.itemsCount": "{{count}} Artikel",
      "manager.calendar.unknownClient": "Unbekannter Kunde",
      "manager.calendar.defaultService": "Leistung",
      "manager.calendar.withStaff": "mit",
      "manager.calendar.defaultStaff": "Personal",
      "manager.calendar.endsAt": "Endet {{time}}",
      "manager.calendar.riskPill": "Risiko: {{tier}}",
      "manager.calendar.noAppointments": "Keine Termine für diesen Filter.",
      "manager.calendar.prompt.reschedule": "Geben Sie die neue Startzeit im ISO-Format ein (z. B. 2026-02-20T10:00:00Z)",
      "manager.calendar.status.all": "Alle Status",
      "manager.calendar.status.pending_confirmation": "Bestätigung steht aus",
      "manager.calendar.status.confirmed": "Bestätigt",
      "manager.calendar.status.completed": "Vollendet",
      "manager.calendar.status.cancelled": "Abgesagt",
      "manager.calendar.status.no_show": "No-Show",
      "manager.calendar.action.confirm": "Bestätigen",
      "manager.calendar.action.cancel": "Stornieren",
      "manager.calendar.action.complete": "Vollständig",
      "manager.calendar.action.no_show": "No-Show",
      "manager.calendar.action.reschedule": "Neu planen",
      "manager.inventory.title": "Inventar",
      "manager.inventory.products": "Produkte",
      "manager.inventory.skuValue": "Artikelnummer {{sku}}",
      "manager.inventory.thresholdValue": "Schwellenwert für niedrigen Lagerbestand: {{count}}",
      "manager.inventory.createProduct": "Produkt erstellen",
      "manager.inventory.placeholder.sku": "Artikelnummer",
      "manager.inventory.placeholder.name": "Name",
      "manager.inventory.placeholder.locationName": "Standortname",
      "manager.inventory.action.addProduct": "Produkt hinzufügen",
      "manager.inventory.stockLocations": "Lagerstandorte",
      "manager.inventory.action.addLocation": "Standort hinzufügen",
      "manager.services.title": "Servicekatalog",
      "manager.services.addService": "Dienst hinzufügen",
      "manager.services.placeholder.serviceName": "Dienstname",
      "manager.services.action.createService": "Dienst erstellen",
      "manager.staff.title": "Personal & Fähigkeiten",
      "manager.staff.team": "Team",
      "manager.staff.unknownBranch": "Unbekannter Zweig",
      "manager.staff.skillsValue": "Fähigkeiten: {{value}}",
      "manager.staff.none": "keiner",
      "manager.staff.addMember": "Mitarbeiter hinzufügen",
      "manager.staff.placeholder.fullName": "Vollständiger Name",
      "manager.staff.placeholder.skills": "Fertigkeiten durch Kommas getrennt",
      "manager.staff.action.addStaff": "Personal hinzufügen",
      "manager.settings.title": "Einstellungen",
      "manager.settings.tenantProfile": "Mieterprofil",
      "manager.settings.featureFlags": "Feature-Flags",
      "manager.settings.field.name": "Name",
      "manager.settings.field.slug": "Schnecke",
      "manager.settings.field.status": "Status",
      "manager.settings.field.locale": "Gebietsschema",
      "manager.settings.field.plan": "Planen",
      "manager.settings.notSet": "nicht eingestellt",
      "manager.settings.messagingStrategy": "Messaging-Strategie",
      "manager.settings.messagingStrategyHelp": "Konfigurieren Sie Telegram-First- oder anderes Channel-First-Verhalten pro Mandant/market.",
      "manager.settings.field.marketProfile": "Marktprofil",
      "manager.settings.field.primaryMessenger": "Hauptbote",
      "manager.settings.field.messengerFirstMode": "Messenger-First-Modus",
      "manager.settings.marketProfile.default": "Standard (gemischte Kanäle)",
      "manager.settings.marketProfile.telegram_first": "Telegram-first",
      "manager.settings.marketProfile.whatsapp_first": "WhatsApp-zuerst",
      "manager.settings.primaryMessenger.none": "Keiner",
      "manager.settings.primaryMessenger.telegram": "Telegramm",
      "manager.settings.primaryMessenger.whatsapp": "WhatsApp",
      "manager.settings.primaryMessenger.sms": "SMS",
      "manager.settings.primaryMessenger.email": "E-Mail",
      "manager.settings.saveStrategy": "Strategie speichern",
      "manager.settings.saving": "Sparen...",
      "manager.settings.strategySaved": "Nachrichtenstrategie gespeichert.",
      "manager.settings.saveFailed": "Einstellungen konnten nicht gespeichert werden.",
      "manager.settings.channelCapabilities": "Kanalfunktionen",
      "manager.settings.noCapabilities": "Keine Kanalfunktionen verfügbar.",
      "manager.settings.cap.managerApp": "Eingebettete Manager-App",
      "manager.settings.cap.clientApp": "Client-eingebettete App",
      "manager.settings.cap.freeformOutbound": "Freiform-Outbound",
      "manager.settings.cap.templateOnlyOutbound": "Ausgehend nur mit Vorlage",
      "manager.settings.cap.deepLinks": "Deep-Links",
      "manager.settings.cap.identityLinking": "Identitätsverknüpfung",
      "manager.integrations.title": "Integrationen",
      "manager.integrations.activateBot": "Aktivieren Sie den Telegram-Bot",
      "manager.integrations.activateBotHelp": "Neuinstallationen erfordern eine Telegram-Integration mit Bot-Token. Token von BotFather einfügen und dann speichern. Dadurch wird die Integration erstellt, falls sie noch nicht vorhanden ist, oder eine vorhandene aktualisiert.",
      "manager.integrations.placeholder.integrationName": "Integrationsname",
      "manager.integrations.placeholder.botToken": "Telegram-Bot-Token (z. B. 123456:ABC...)",
      "manager.integrations.placeholder.chatId": "Ihre Telegram-Chat-ID (z. B. 123456789)",
      "manager.integrations.placeholder.yourChatId": "Ihre Chat-ID: {{chatId}}",
      "manager.integrations.placeholder.recipientChatId": "Chat-ID des Empfängers",
      "manager.integrations.placeholder.messageText": "Nachrichtentext",
      "manager.integrations.placeholder.template": "Schreiben Sie hier eine Telegram-Markdown-Vorlage",
      "manager.integrations.defaultBotName": "Haupttelegramm-Bot",
      "manager.integrations.saving": "Sparen...",
      "manager.integrations.syncing": "Synchronisierung...",
      "manager.integrations.sending": "Senden...",
      "manager.integrations.action.saveBot": "Speichern Sie Telegram Bot",
      "manager.integrations.action.syncWebhook": "Webhook synchronisieren",
      "manager.integrations.action.unlink": "Verknüpfung aufheben",
      "manager.integrations.action.useMyChatId": "Benutze meine chat_id",
      "manager.integrations.action.sendTest": "Test senden",
      "manager.integrations.action.saveTemplate": "Vorlage speichern",
      "manager.integrations.action.resetDefault": "Auf Standard zurücksetzen",
      "manager.integrations.connectedChannels": "Verbundene Kanäle",
      "manager.integrations.linkTelegram": "Verlinken Sie Ihr Telegramm",
      "manager.integrations.linkTelegramHelp1": "Geben Sie Ihre Telegram-Chat-ID ein, um Buchungsbenachrichtigungen zu erhalten und Bot-Befehle zu verwenden",
      "manager.integrations.linkTelegramHelp2": "So finden Sie Ihre Chat-ID: Öffnen Sie Telegram und senden Sie eine Nachricht",
      "manager.integrations.linkTelegramHelp3": "- Es wird mit Ihrer numerischen ID geantwortet.",
      "manager.integrations.currentlyLinked": "Derzeit verlinkt:",
      "manager.integrations.sendTestMessage": "Testnachricht senden",
      "manager.integrations.sendTestHelp": "Senden Sie eine Test-Telegram-Nachricht an eine beliebige chat_id, um zu überprüfen, ob die Integration funktioniert. Wählen Sie oben zunächst einen Kanal aus.",
      "manager.integrations.selectChannelToSend": "Wählen Sie oben einen Kanal aus, um das Senden zu aktivieren.",
      "manager.integrations.noTelegramIntegrations": "Keine Telegram-Integrationen gefunden.",
      "manager.integrations.noResultYet": "Noch kein Ergebnis.",
      "manager.integrations.bookingTemplateTitle": "Vorlage für die Bestätigung einer Kundenbuchung",
      "manager.integrations.bookingTemplateHelp": "Telegram unterstützt Markdown in dieser Vorlage. Platzhalter:",
      "manager.integrations.selectTelegramFirst": "Wählen Sie oben zunächst einen Telegram-Kanal aus.",
      "manager.integrations.selectedNotTelegram": "Der ausgewählte Kanal ist kein Telegram.",
      "manager.integrations.result.savedChatId": "Gespeichert! Ihre Telegram-Chat-ID: {{chatId}}",
      "manager.integrations.result.telegramActive": "Telegram-Integration ist aktiv: {{name}} ({{id}})",
      "manager.integrations.result.savedTemplate": "Gespeicherte Buchungsbestätigungsvorlage.",
      "manager.integrations.error.enterToken": "Geben Sie den Telegram-Bot-Token ein.",
      "manager.integrations.error.selectTelegramFirst": "Erstellen oder wählen Sie zunächst eine Telegram-Integration aus.",
      "manager.integrations.cleared": "gelöscht",
      "manager.branding.title": "Branding-Studio",
      "manager.branding.unsaved": "Nicht gespeicherte Änderungen",
      "manager.branding.saved": "Gespeichert",
      "manager.branding.previewing": "Vorschau {{mode}}",
      "manager.branding.previewMode.draft": "Entwurfsvorschau",
      "manager.branding.previewMode.published": "Veröffentlichte Vorschau",
      "manager.branding.action.saveDraft": "Entwurf speichern",
      "manager.branding.action.publish": "Veröffentlichen",
      "manager.branding.action.up": "Hoch",
      "manager.branding.action.down": "Runter",
      "manager.branding.action.rollbackToDraft": "Rollback auf Entwurf",
      "manager.branding.publishHint": "Die Veröffentlichung umfasst nicht gespeicherte lokale Änderungen (der Entwurf wird zuerst automatisch gespeichert).",
      "manager.branding.panel.brandKit": "Markenkit",
      "manager.branding.panel.layout": "Layout und Komponenten",
      "manager.branding.panel.media": "Medienbibliothek",
      "manager.branding.panel.content": "Inhalt",
      "manager.branding.panel.publish": "Vorschau und Veröffentlichung",
      "manager.branding.panel.advanced": "Fortschrittlich",
      "manager.branding.pageSections": "Seitenabschnitte",
      "manager.branding.tokens": "Token",
      "manager.branding.baseSize": "Grundgröße",
      "manager.branding.sectionInspector": "Abschnittsinspektor",
      "manager.branding.noSectionSelected": "Kein Abschnitt ausgewählt",
      "manager.branding.sectionVariant": "Abschnittsvariante",
      "manager.branding.default": "Standard",
      "manager.branding.header": "Kopfzeile",
      "manager.branding.alignLeft": "Links ausrichten",
      "manager.branding.alignCenter": "Zentriert ausrichten",
      "manager.branding.compactPadding": "Kompakte Polsterung",
      "manager.branding.mediumPadding": "Mittlere Polsterung",
      "manager.branding.largePadding": "Große Polsterung",
      "manager.branding.list": "Liste",
      "manager.branding.grid": "Netz",
      "manager.branding.cardsWithImages": "Karten mit Bildern",
      "manager.branding.imageCover": "Bildcover",
      "manager.branding.imageContain": "Bild enthalten",
      "manager.branding.showDuration": "Dauer anzeigen",
      "manager.branding.showPrice": "Preis anzeigen",
      "manager.branding.pills": "Pillen",
      "manager.branding.cardsWithPhotos": "Karten mit Fotos",
      "manager.branding.showPhotos": "Fotos anzeigen",
      "manager.branding.timeSlots": "Zeitfenster",
      "manager.branding.outline": "Gliederung",
      "manager.branding.filled": "Gefüllt",
      "manager.branding.small": "Klein",
      "manager.branding.medium": "Medium",
      "manager.branding.stepper": "Stepper",
      "manager.branding.numbers": "Zahlen",
      "manager.branding.dots": "Punkte",
      "manager.branding.showLabels": "Beschriftungen anzeigen",
      "manager.branding.form": "Bilden",
      "manager.branding.smallRadius": "Kleiner Radius",
      "manager.branding.mediumRadius": "Mittlerer Radius",
      "manager.branding.largeRadius": "Großer Radius",
      "manager.branding.mediaLibrary": "Medienbibliothek",
      "manager.branding.heroMain": "Hauptheld: {{id}} | Aux-Fotos: {{count}}",
      "manager.branding.mediaHint": "Filtern Sie nach Typ, um Assets schneller zu finden. Mit den Hauptschaltflächen/Aux wird Ihr Entwurf aktualisiert.",
      "manager.branding.filter.all": "Alle",
      "manager.branding.filter.hero": "Held",
      "manager.branding.filter.logo": "Logo",
      "manager.branding.filter.service": "Leistung",
      "manager.branding.filter.staff": "Personal",
      "manager.branding.search": "Suchen",
      "manager.branding.altText": "Alt-Text",
      "manager.branding.mainHeroSelected": "Hauptheld (Entwurf ausgewählt)",
      "manager.branding.setMainHero": "Als Hauptheld festlegen (Entwurf)",
      "manager.branding.removeAux": "Aux entfernen",
      "manager.branding.addAux": "Aux hinzufügen",
      "manager.branding.publicContent": "Öffentlicher Inhalt",
      "manager.branding.placeholder.headerTitle": "Titel der Kopfzeile",
      "manager.branding.placeholder.headerSubtitle": "Untertitel im Header",
      "manager.branding.placeholder.beforeYouArrive": "Bevor Sie ankommen",
      "manager.branding.versionHistory": "Versionsverlauf",
      "manager.branding.placeholder.publishNotes": "Notizen veröffentlichen (optional)",
      "manager.branding.noNotes": "Keine Notizen",
      "manager.branding.accessibilitySafety": "Zugänglichkeit und Sicherheit",
      "manager.branding.noWarnings": "Keine Warnungen.",
      "manager.branding.warning.contrastPrimary": "Geringer Kontrast: Text auf der Primärseite",
      "manager.branding.warning.contrastSurface": "Geringer Kontrast: Text auf der Oberfläche",
      "manager.branding.warning.missingAlt": "{{count}} Medienelement(en) ohne Alternativtext",
      "manager.branding.publishedVersion": "Veröffentlichte Version: {{version}}",
      "manager.branding.draftUpdated": "Entwurf aktualisiert: {{value}}",
      "manager.clients.placeholder.fullName": "Vollständiger Name",
      "manager.clients.placeholder.phone": "Telefon",
      "manager.clients.placeholder.email": "E-Mail",
      "manager.clients.placeholder.message": "Schreiben Sie eine Nachricht mit Markdown: **fett**, *kursiv*, [Link](https://...)",
      "manager.clients.noBranch": "Keine Filiale",
      "manager.clients.aria.editLocale": "Bearbeiten Sie das Client-Gebietsschema",
      "manager.clients.aria.editBookingMode": "Kundenbuchungsmodus bearbeiten",
      "manager.clients.aria.newLocale": "Neues Client-Gebietsschema",
      "manager.clients.aria.newBookingMode": "Buchungsmodus für neue Kunden",
      "manager.clients.bookingMode.web_page": "Webseite",
      "manager.clients.bookingMode.web_app": "Web-App",
      "manager.clients.bookingMode.both": "Beide",
      "manager.clients.noContact": "Keine Kontaktdaten",
      "manager.clients.riskPill": "Risiko {{tier}} ({{score}})",
      "manager.clients.telegram.linked": "Telegramm verlinkt",
      "manager.clients.telegram.unlinked": "Telegramm nicht verlinkt",
      "manager.clients.localePill": "Gebietsschema {{locale}}",
      "manager.clients.stats": "Besuche {{visits}} | Abgeschlossen {{completed}} | Nichterscheinen {{noShow}}",
      "manager.clients.action.restore": "Wiederherstellen",
      "manager.clients.action.archive": "Archiv",
      "manager.clients.action.saveClient": "Kunde speichern",
      "manager.clients.riskSummary": "Ergebnis: {{score}} | Stufe: {{tier}}",
      "manager.clients.noFactors": "Keine Faktoren verfügbar.",
      "manager.clients.loadingConversation": "Konversation wird geladen...",
      "manager.clients.noHistory": "Noch keine Geschichte.",
      "manager.clients.sendMessage": "Nachricht senden",
      "manager.clients.telegramLinkHint.before": "Telegram ist für diesen Kunden nicht verlinkt. Bitten Sie sie, zu senden",
      "manager.clients.telegramLinkHint.andThen": "Dann",
      "manager.clients.telegramLinkHint.after": "zu deinem Bot. Wenn sie zuvor verknüpft waren, können Sie trotzdem versuchen, sie zu senden. Der Server versucht dann, die Chat-ID aus dem Verlauf wiederherzustellen.",
      "manager.clients.template.confirmReminder": "Erinnerung bestätigen",
      "manager.clients.template.noShow": "Nachverfolgung bei Nichterscheinen",
      "manager.clients.template.reactivation": "Reaktivierung",
      "manager.clients.channel.telegram": "Telegramm",
      "manager.clients.channel.sms": "SMS",
      "manager.clients.channel.email": "E-Mail",
      "manager.clients.attachment": "Anhang",
      "manager.clients.action.removeAttachment": "Anhang entfernen",
      "manager.clients.preview": "Vorschau",
      "manager.clients.action.send": "Schicken",
    },
  },
  ru: {
    translation: {
      appTitle: "Salon OS",
      login: "\u0412\u0445\u043e\u0434",
      logout: "\u0412\u044b\u0445\u043e\u0434",
      language: "\u042f\u0437\u044b\u043a",
      dashboard: "\u0414\u0430\u0448\u0431\u043e\u0440\u0434",
      calendar: "\u041a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044c",
      clients: "\u041a\u043b\u0438\u0435\u043d\u0442\u044b",
      staff: "\u0421\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0438",
      services: "\u0423\u0441\u043b\u0443\u0433\u0438",
      inventory: "\u0421\u043a\u043b\u0430\u0434",
      automation: "\u0410\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044f",
      integrations: "\u0418\u043d\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
      analytics: "\u0410\u043d\u0430\u043b\u0438\u0442\u0438\u043a\u0430",
      settings: "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438",
      loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430...",
      save: "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
      refresh: "\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c",
      "manager.command": "\u041f\u0430\u043d\u0435\u043b\u044c \u043c\u0435\u043d\u0435\u0434\u0436\u0435\u0440\u0430",
      "common.status": "\u0421\u0442\u0430\u0442\u0443\u0441",
      "nav.dashboard": "\u0414\u0430\u0448\u0431\u043e\u0440\u0434",
      "nav.calendar": "\u041a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044c",
      "nav.clients": "\u041a\u043b\u0438\u0435\u043d\u0442\u044b",
      "nav.staff": "\u0421\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0438",
      "nav.services": "\u0423\u0441\u043b\u0443\u0433\u0438",
      "nav.inventory": "\u0421\u043a\u043b\u0430\u0434",
      "nav.automation": "\u0410\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044f",
      "nav.integrations": "\u0418\u043d\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
      "nav.branding": "\u0411\u0440\u0435\u043d\u0434\u0438\u043d\u0433",
      "nav.settings": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438",
      "locale.en": "\u0410\u043d\u0433\u043b\u0438\u0439\u0441\u043a\u0438\u0439",
      "locale.ru": "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
      "locale.es": "\u0418\u0441\u043f\u0430\u043d\u0441\u043a\u0438\u0439",
      "locale.de": "\u041d\u0435\u043c\u0435\u0446\u043a\u0438\u0439",
      "locale.fa": "\u041f\u0435\u0440\u0441\u0438\u0434\u0441\u043a\u0438\u0439",
      "manager.clients.intelligence": "\u0418\u043d\u0442\u0435\u043b\u043b\u0435\u043a\u0442 \u043f\u043e \u043a\u043b\u0438\u0435\u043d\u0442\u0430\u043c",
      "manager.clients.title": "\u041a\u043b\u0438\u0435\u043d\u0442\u044b",
      "manager.clients.tab.active": "\u0410\u043a\u0442\u0438\u0432\u043d\u044b\u0435",
      "manager.clients.tab.archived": "\u0410\u0440\u0445\u0438\u0432",
      "manager.clients.searchPlaceholder": "\u041f\u043e\u0438\u0441\u043a \u043f\u043e \u0438\u043c\u0435\u043d\u0438 / \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443 / email",
      "manager.clients.filter.risk": "\u0420\u0438\u0441\u043a",
      "manager.clients.filter.telegram": "Telegram",
      "manager.clients.filter.all": "\u0412\u0441\u0435",
      "manager.clients.filter.linked": "\u041f\u0440\u0438\u0432\u044f\u0437\u0430\u043d\u044b",
      "manager.clients.filter.unlinked": "\u041d\u0435 \u043f\u0440\u0438\u0432\u044f\u0437\u0430\u043d\u044b",
      "manager.clients.risk.minimal": "\u043c\u0438\u043d\u0438\u043c\u0430\u043b\u044c\u043d\u044b\u0439",
      "manager.clients.risk.low": "\u043d\u0438\u0437\u043a\u0438\u0439",
      "manager.clients.risk.medium": "\u0441\u0440\u0435\u0434\u043d\u0438\u0439",
      "manager.clients.risk.high": "\u0432\u044b\u0441\u043e\u043a\u0438\u0439",
      "manager.clients.visibleCount": "\u0412\u0438\u0434\u0438\u043c\u043e: {{count}}",
      "manager.clients.listTitle": "\u0421\u043f\u0438\u0441\u043e\u043a \u043a\u043b\u0438\u0435\u043d\u0442\u043e\u0432",
      "manager.clients.noClients": "\u041a\u043b\u0438\u0435\u043d\u0442\u044b \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u044b.",
      "manager.clients.addTitle": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043a\u043b\u0438\u0435\u043d\u0442\u0430",
      "manager.clients.conversationTitle": "\u0414\u0438\u0430\u043b\u043e\u0433 \u0441 \u043a\u043b\u0438\u0435\u043d\u0442\u043e\u043c",
      "manager.clients.selectHint": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043b\u0438\u0435\u043d\u0442\u0430 \u0434\u043b\u044f \u043f\u0440\u043e\u0441\u043c\u043e\u0442\u0440\u0430 \u0440\u0438\u0441\u043a\u0430 \u0438 \u0438\u0441\u0442\u043e\u0440\u0438\u0438 \u0434\u0438\u0430\u043b\u043e\u0433\u0430.",
      "manager.clients.notice.created": "\u041a\u043b\u0438\u0435\u043d\u0442 \u0441\u043e\u0437\u0434\u0430\u043d.",
      "manager.clients.notice.updated": "\u041a\u043b\u0438\u0435\u043d\u0442 \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d.",
      "manager.clients.notice.archived": "\u041a\u043b\u0438\u0435\u043d\u0442 \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043e\u0432\u0430\u043d.",
      "manager.clients.notice.restored": "\u041a\u043b\u0438\u0435\u043d\u0442 \u0432\u043e\u0441\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d.",
      "manager.clients.notice.sent": "\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e.",
      "common.save": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c",
      "common.cancel": "\u041e\u0442\u043c\u0435\u043d\u0430",
      "common.edit": "\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c",
      "common.delete": "\u0423\u0434\u0430\u043b\u0438\u0442\u044c",
      "common.active": "\u0410\u043a\u0442\u0438\u0432\u0435\u043d",
      "common.enabled": "\u0432\u043a\u043b\u044e\u0447\u0435\u043d\u043e",
      "common.disabled": "\u0432\u044b\u043a\u043b\u044e\u0447\u0435\u043d\u043e",
      "manager.layout.tenantFallback": "\u0421\u0430\u043b\u043e\u043d",
      "manager.layout.unknown": "\u043d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u043e",
      "manager.dashboard.ribbon.overline": "\u0426\u0435\u043d\u0442\u0440 \u0443\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044f \u043c\u0435\u043d\u0435\u0434\u0436\u0435\u0440\u0430",
      "manager.dashboard.ribbon.title": "\u0421 \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0435\u043d\u0438\u0435\u043c",
      "manager.dashboard.branchScope": "\u0424\u0438\u043b\u0438\u0430\u043b",
      "manager.dashboard.allBranches": "\u0412\u0441\u0435 \u0444\u0438\u043b\u0438\u0430\u043b\u044b",
      "manager.dashboard.kpi.todayAppointments": "\u0417\u0430\u043f\u0438\u0441\u0438 \u0441\u0435\u0433\u043e\u0434\u043d\u044f",
      "manager.dashboard.kpi.noShowRate": "\u0414\u043e\u043b\u044f \u043d\u0435\u044f\u0432\u043e\u043a",
      "manager.dashboard.kpi.queuePending": "\u0412 \u043e\u0447\u0435\u0440\u0435\u0434\u0438",
      "manager.dashboard.kpi.lowStockAlerts": "\u041d\u0438\u0437\u043a\u0438\u0439 \u043e\u0441\u0442\u0430\u0442\u043e\u043a",
      "manager.dashboard.queueFailed24h": "\u0421\u0431\u043e\u0435\u0432 \u0437\u0430 24\u0447: {{count}}",
      "manager.dashboard.noQueueFailures24h": "\u0421\u0431\u043e\u0435\u0432 \u0437\u0430 24\u0447 \u043d\u0435\u0442",
      "manager.dashboard.oldestPendingAge": "\u0421\u0430\u043c\u0430\u044f \u0441\u0442\u0430\u0440\u0430\u044f \u0437\u0430\u0434\u0430\u0447\u0430 \u0432 \u043e\u0447\u0435\u0440\u0435\u0434\u0438: {{minutes}} \u043c\u0438\u043d",
      "manager.dashboard.todayRhythm": "\u0420\u0438\u0442\u043c \u0434\u043d\u044f",
      "manager.dashboard.liveStatusMix": "\u0421\u0442\u0430\u0442\u0443\u0441\u044b \u0437\u0430\u043f\u0438\u0441\u0435\u0439",
      "manager.dashboard.loadingRhythm": "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0440\u0438\u0442\u043c\u0430...",
      "manager.dashboard.status.pending": "\u041e\u0436\u0438\u0434\u0430\u0435\u0442 {{count}}",
      "manager.dashboard.status.confirmed": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043e {{count}}",
      "manager.dashboard.status.completed": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043e {{count}}",
      "manager.dashboard.status.cancelled": "\u041e\u0442\u043c\u0435\u043d\u0435\u043d\u043e {{count}}",
      "manager.dashboard.status.noShow": "\u041d\u0435\u044f\u0432\u043a\u0430 {{count}}",
      "manager.dashboard.upcomingHighRisk": "\u0411\u043b\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0432\u044b\u0441\u043e\u043a\u0438\u0435 \u0440\u0438\u0441\u043a\u0438",
      "manager.dashboard.defaultService": "\u0423\u0441\u043b\u0443\u0433\u0430",
      "manager.dashboard.withStaff": "\u0441",
      "manager.dashboard.defaultStaff": "\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0441\u0442",
      "manager.dashboard.noUpcomingHighRisk": "\u0412\u044b\u0441\u043e\u043a\u0438\u0445 \u0440\u0438\u0441\u043a\u043e\u0432 \u043d\u0435\u0442.",
      "manager.dashboard.recommendations": "\u0420\u0435\u043a\u043e\u043c\u0435\u043d\u0434\u0430\u0446\u0438\u0438",
      "manager.dashboard.topStaff30d": "\u041b\u0443\u0447\u0448\u0438\u0435 \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0438 (30\u0434)",
      "manager.dashboard.loadingStaff": "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0438...",
      "manager.dashboard.completed": "\u0412\u044b\u043f\u043e\u043b\u043d\u0435\u043d\u043e: {{count}}",
      "manager.dashboard.noShowRate": "\u0414\u043e\u043b\u044f \u043d\u0435\u044f\u0432\u043e\u043a: {{value}}%",
      "manager.dashboard.revenue": "\u0412\u044b\u0440\u0443\u0447\u043a\u0430: ${{value}}",
      "manager.dashboard.noStaffData": "\u041f\u043e\u043a\u0430 \u043d\u0435\u0442 \u0434\u0430\u043d\u043d\u044b\u0445.",
      "manager.dashboard.reco.noShow.title": "\u0420\u043e\u0441\u0442 \u043d\u0435\u044f\u0432\u043e\u043a",
      "manager.dashboard.reco.noShow.body": "\u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u043a\u043b\u0438\u0435\u043d\u0442\u043e\u0432 \u0432\u044b\u0441\u043e\u043a\u043e\u0433\u043e \u0440\u0438\u0441\u043a\u0430 \u0438 \u0437\u0430\u043f\u0443\u0441\u0442\u0438\u0442\u0435 \u043d\u0430\u043f\u043e\u043c\u0438\u043d\u0430\u043d\u0438\u044f.",
      "manager.dashboard.reco.messaging.title": "\u0415\u0441\u0442\u044c \u043e\u0448\u0438\u0431\u043a\u0438 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439",
      "manager.dashboard.reco.messaging.body": "\u0421\u0431\u043e\u0435\u0432 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439 \u0437\u0430 24\u0447: {{count}}",
      "manager.dashboard.reco.inventory.title": "\u0420\u0438\u0441\u043a \u043f\u043e \u0441\u043a\u043b\u0430\u0434\u0443",
      "manager.dashboard.reco.inventory.body": "\u041f\u043e\u0437\u0438\u0446\u0438\u0439 \u043d\u0430 \u043f\u043e\u0440\u043e\u0433\u0435: {{count}}",
      "manager.dashboard.reco.upcoming.title": "\u0411\u043b\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0440\u0438\u0441\u043a\u043e\u0432\u044b\u0435 \u0437\u0430\u043f\u0438\u0441\u0438",
      "manager.dashboard.reco.upcoming.body": "\u0411\u043b\u0438\u0436\u0430\u0439\u0448\u0438\u0445 \u0440\u0438\u0441\u043a\u043e\u0432\u044b\u0445 \u0437\u0430\u043f\u0438\u0441\u0435\u0439: {{count}}",
      "manager.dashboard.reco.healthy.title": "\u041e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u0441\u0442\u0430\u0431\u0438\u043b\u044c\u043d\u044b",
      "manager.dashboard.reco.healthy.body": "\u041e\u0447\u0435\u0440\u0435\u0434\u0438 \u0438 \u0438\u043d\u0434\u0438\u043a\u0430\u0442\u043e\u0440\u044b \u0432 \u043d\u043e\u0440\u043c\u0435.",
      "manager.dashboard.reco.openClients": "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043a\u043b\u0438\u0435\u043d\u0442\u043e\u0432",
      "manager.dashboard.reco.openIntegrations": "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u0438\u043d\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
      "manager.dashboard.reco.openInventory": "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u0441\u043a\u043b\u0430\u0434",
      "manager.dashboard.reco.openCalendar": "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044c",
      "manager.clients.placeholder.fullName": "\u041f\u043e\u043b\u043d\u043e\u0435 \u0438\u043c\u044f",
      "manager.clients.placeholder.phone": "\u0422\u0435\u043b\u0435\u0444\u043e\u043d",
      "manager.clients.placeholder.email": "Email",
      "manager.clients.placeholder.message": "\u041d\u0430\u043f\u0438\u0448\u0438\u0442\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u0432 markdown: **bold**, *italic*, [link](https://...)",
      "manager.clients.noBranch": "\u0411\u0435\u0437 \u0444\u0438\u043b\u0438\u0430\u043b\u0430",
      "manager.clients.bookingMode.web_page": "Web \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0430",
      "manager.clients.bookingMode.web_app": "Web \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435",
      "manager.clients.bookingMode.both": "\u041e\u0431\u0430",
      "manager.clients.action.saveClient": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043a\u043b\u0438\u0435\u043d\u0442\u0430",
      "manager.clients.sendMessage": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435",
      "manager.clients.action.send": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c",
      "manager.clients.preview": "\u041f\u0440\u0435\u0432\u044c\u044e",
      "manager.calendar.title": "\u041e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u043a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u044f",
      "manager.calendar.subtitle": "\u041f\u0440\u0438\u043e\u0440\u0438\u0442\u0435\u0442 \u043f\u043e \u0440\u0438\u0441\u043a\u0443, \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u0438 \u0440\u0438\u0442\u043c\u0443.",
      "manager.calendar.ribbon.overline": "\u0420\u0435\u0436\u0438\u043c \u0440\u0435\u0448\u0435\u043d\u0438\u0439",
      "manager.calendar.branch": "\u0424\u0438\u043b\u0438\u0430\u043b",
      "manager.calendar.allBranches": "\u0412\u0441\u0435 \u0444\u0438\u043b\u0438\u0430\u043b\u044b",
      "manager.calendar.appointmentsTitle": "\u0417\u0430\u043f\u0438\u0441\u0438 ({{day}})",
      "manager.calendar.itemsCount": "{{count}} \u0448\u0442.",
      "manager.calendar.unknownClient": "\u041d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u044b\u0439 \u043a\u043b\u0438\u0435\u043d\u0442",
      "manager.calendar.defaultService": "\u0423\u0441\u043b\u0443\u0433\u0430",
      "manager.calendar.withStaff": "\u0441",
      "manager.calendar.defaultStaff": "\u0421\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0441\u0442",
      "manager.calendar.endsAt": "\u0414\u043e {{time}}",
      "manager.calendar.status.all": "\u0412\u0441\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044b",
      "manager.calendar.status.pending_confirmation": "\u0416\u0434\u0435\u0442 \u043f\u043e\u0434\u0442\u0432.",
      "manager.calendar.status.confirmed": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u043e",
      "manager.calendar.status.completed": "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u043e",
      "manager.calendar.status.cancelled": "\u041e\u0442\u043c\u0435\u043d\u0435\u043d\u043e",
      "manager.calendar.status.no_show": "\u041d\u0435\u044f\u0432\u043a\u0430",
      "manager.calendar.action.confirm": "\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c",
      "manager.calendar.action.cancel": "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c",
      "manager.calendar.action.complete": "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044c",
      "manager.calendar.action.no_show": "\u041d\u0435\u044f\u0432\u043a\u0430",
      "manager.calendar.action.reschedule": "\u041f\u0435\u0440\u0435\u043d\u0435\u0441\u0442\u0438",
      "manager.calendar.noAppointments": "\u041d\u0435\u0442 \u0437\u0430\u043f\u0438\u0441\u0435\u0439 \u043f\u043e \u0444\u0438\u043b\u044c\u0442\u0440\u0443.",
      "manager.inventory.title": "\u0421\u043a\u043b\u0430\u0434",
      "manager.inventory.products": "\u0422\u043e\u0432\u0430\u0440\u044b",
      "manager.inventory.createProduct": "\u041d\u043e\u0432\u044b\u0439 \u0442\u043e\u0432\u0430\u0440",
      "manager.inventory.placeholder.sku": "SKU",
      "manager.inventory.placeholder.name": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435",
      "manager.inventory.placeholder.locationName": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043b\u043e\u043a\u0430\u0446\u0438\u0438",
      "manager.inventory.action.addProduct": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0442\u043e\u0432\u0430\u0440",
      "manager.inventory.stockLocations": "\u041b\u043e\u043a\u0430\u0446\u0438\u0438 \u0441\u043a\u043b\u0430\u0434\u0430",
      "manager.inventory.action.addLocation": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u043b\u043e\u043a\u0430\u0446\u0438\u044e",
      "manager.services.title": "\u041a\u0430\u0442\u0430\u043b\u043e\u0433 \u0443\u0441\u043b\u0443\u0433",
      "manager.services.addService": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0443\u0441\u043b\u0443\u0433\u0443",
      "manager.services.placeholder.serviceName": "\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0443\u0441\u043b\u0443\u0433\u0438",
      "manager.services.action.createService": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0443\u0441\u043b\u0443\u0433\u0443",
      "manager.staff.title": "\u0421\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0438 \u0438 \u043d\u0430\u0432\u044b\u043a\u0438",
      "manager.staff.team": "\u041a\u043e\u043c\u0430\u043d\u0434\u0430",
      "manager.staff.unknownBranch": "\u041d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u044b\u0439 \u0444\u0438\u043b\u0438\u0430\u043b",
      "manager.staff.skillsValue": "\u041d\u0430\u0432\u044b\u043a\u0438: {{value}}",
      "manager.staff.none": "\u043d\u0435\u0442",
      "manager.staff.addMember": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0430",
      "manager.staff.placeholder.fullName": "\u0424\u0418\u041e",
      "manager.staff.placeholder.skills": "\u043d\u0430\u0432\u044b\u043a\u0438 \u0447\u0435\u0440\u0435\u0437 \u0437\u0430\u043f\u044f\u0442\u0443\u044e",
      "manager.staff.action.addStaff": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0430",
      "manager.settings.title": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438",
      "manager.settings.tenantProfile": "\u041f\u0440\u043e\u0444\u0438\u043b\u044c \u0441\u0430\u043b\u043e\u043d\u0430",
      "manager.settings.featureFlags": "\u0424\u043b\u0430\u0433\u0438",
      "manager.settings.field.name": "\u0418\u043c\u044f",
      "manager.settings.field.slug": "Slug",
      "manager.settings.field.status": "\u0421\u0442\u0430\u0442\u0443\u0441",
      "manager.settings.field.locale": "\u042f\u0437\u044b\u043a",
      "manager.settings.field.plan": "\u0422\u0430\u0440\u0438\u0444",
      "manager.settings.notSet": "\u043d\u0435 \u0437\u0430\u0434\u0430\u043d\u043e",
      "manager.settings.messagingStrategy": "Messaging Strategy",
      "manager.settings.messagingStrategyHelp": "Configure Telegram-first or other channel-first behavior per tenant/market.",
      "manager.settings.field.marketProfile": "Market profile",
      "manager.settings.field.primaryMessenger": "Primary messenger",
      "manager.settings.field.messengerFirstMode": "Messenger-first mode",
      "manager.settings.marketProfile.default": "Default (mixed channels)",
      "manager.settings.marketProfile.telegram_first": "Telegram-first",
      "manager.settings.marketProfile.whatsapp_first": "WhatsApp-first",
      "manager.settings.primaryMessenger.none": "None",
      "manager.settings.primaryMessenger.telegram": "Telegram",
      "manager.settings.primaryMessenger.whatsapp": "WhatsApp",
      "manager.settings.primaryMessenger.sms": "SMS",
      "manager.settings.primaryMessenger.email": "Email",
      "manager.settings.saveStrategy": "Save Strategy",
      "manager.settings.saving": "Saving...",
      "manager.settings.strategySaved": "Messaging strategy saved.",
      "manager.settings.saveFailed": "Failed to save settings.",
      "manager.settings.channelCapabilities": "Channel Capabilities",
      "manager.settings.noCapabilities": "No channel capabilities available.",
      "manager.settings.cap.managerApp": "Manager embedded app",
      "manager.settings.cap.clientApp": "Client embedded app",
      "manager.settings.cap.freeformOutbound": "Free-form outbound",
      "manager.settings.cap.templateOnlyOutbound": "Template-only outbound",
      "manager.settings.cap.deepLinks": "Deep links",
      "manager.settings.cap.identityLinking": "Identity linking",
      "manager.integrations.title": "\u0418\u043d\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
      "manager.integrations.activateBot": "\u041f\u043e\u0434\u043a\u043b\u044e\u0447\u0438\u0442\u044c Telegram \u0431\u043e\u0442\u0430",
      "manager.integrations.action.saveBot": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0431\u043e\u0442\u0430",
      "manager.integrations.action.syncWebhook": "\u0421\u0438\u043d\u0445\u0440. webhook",
      "manager.integrations.connectedChannels": "\u041f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u043d\u044b\u0435 \u043a\u0430\u043d\u0430\u043b\u044b",
      "manager.integrations.linkTelegram": "\u041f\u0440\u0438\u0432\u044f\u0437\u043a\u0430 Telegram",
      "manager.integrations.currentlyLinked": "\u041f\u0440\u0438\u0432\u044f\u0437\u0430\u043d\u043e:",
      "manager.integrations.sendTestMessage": "\u0422\u0435\u0441\u0442 \u043e\u0442\u043f\u0440\u0430\u0432\u043a\u0438",
      "manager.integrations.action.sendTest": "\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0442\u0435\u0441\u0442",
      "manager.integrations.noResultYet": "\u041f\u043e\u043a\u0430 \u043d\u0435\u0442 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0430",
      "manager.integrations.bookingTemplateTitle": "\u0428\u0430\u0431\u043b\u043e\u043d \u043f\u043e\u0434\u0442\u0432. \u0437\u0430\u043f\u0438\u0441\u0438",
      "manager.integrations.action.saveTemplate": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0448\u0430\u0431\u043b\u043e\u043d",
      "manager.integrations.action.resetDefault": "\u0421\u0431\u0440\u043e\u0441\u0438\u0442\u044c \u043f\u043e \u0443\u043c\u043e\u043b\u0447.",
      "manager.branding.title": "\u0411\u0440\u0435\u043d\u0434\u0438\u043d\u0433-\u0441\u0442\u0443\u0434\u0438\u044f",
      "manager.branding.unsaved": "\u041d\u0435\u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0435 \u0438\u0437\u043c\u0435\u043d\u0435\u043d\u0438\u044f",
      "manager.branding.saved": "\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e",
      "manager.branding.action.saveDraft": "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0447\u0435\u0440\u043d\u043e\u0432\u0438\u043a",
      "manager.branding.action.publish": "\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u0442\u044c",
      "manager.branding.pageSections": "\u0421\u0435\u043a\u0446\u0438\u0438",
      "manager.branding.mediaLibrary": "\u041c\u0435\u0434\u0438\u0430\u0431\u0438\u0431\u043b\u0438\u043e\u0442\u0435\u043a\u0430",
      "manager.branding.search": "\u041f\u043e\u0438\u0441\u043a",
      "manager.branding.publicContent": "\u041f\u0443\u0431\u043b\u0438\u0447\u043d\u044b\u0439 \u043a\u043e\u043d\u0442\u0435\u043d\u0442",
      "manager.branding.versionHistory": "\u0418\u0441\u0442\u043e\u0440\u0438\u044f \u0432\u0435\u0440\u0441\u0438\u0439",
      "manager.branding.accessibilitySafety": "\u0414\u043e\u0441\u0442\u0443\u043f\u043d\u043e\u0441\u0442\u044c \u0438 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u043e\u0441\u0442\u044c",
      "manager.branding.noWarnings": "\u041f\u0440\u0435\u0434\u0443\u043f\u0440\u0435\u0436\u0434\u0435\u043d\u0438\u0439 \u043d\u0435\u0442.",
      "manager.branding.warning.contrastPrimary": "\u041d\u0438\u0437\u043a\u0438\u0439 \u043a\u043e\u043d\u0442\u0440\u0430\u0441\u0442: \u0442\u0435\u043a\u0441\u0442 \u043d\u0430 \u043e\u0441\u043d\u043e\u0432\u043d\u043e\u043c",
      "manager.branding.warning.contrastSurface": "\u041d\u0438\u0437\u043a\u0438\u0439 \u043a\u043e\u043d\u0442\u0440\u0430\u0441\u0442: \u0442\u0435\u043a\u0441\u0442 \u043d\u0430 \u0444\u043e\u043d\u0435",
      "manager.branding.warning.missingAlt": "\u0423 \u043c\u0435\u0434\u0438\u0430 \u0431\u0435\u0437 alt: {{count}}",
      "manager.media.selectFromLibrary": "Select from library",
      "manager.media.removePhoto": "Remove Photo",
      "manager.automation.title": "Automation",
      "manager.automation.section.rules": "Reminder Rules",
      "manager.automation.section.flags": "Feature Flags",
      "manager.automation.action.addRule": "Add Rule",
      "manager.automation.action.upsertFlag": "Upsert Flag",
      "manager.automation.currentLocale": "Current locale: {{locale}}",
      "manager.calendar.riskPill": "risk: {{tier}}",
      "manager.calendar.prompt.reschedule": "Enter new start time in ISO format (e.g. 2026-02-20T10:00:00Z)",
      "manager.inventory.skuValue": "SKU {{sku}}",
      "manager.inventory.thresholdValue": "Low stock threshold {{count}}",
      "manager.integrations.activateBotHelp": "Fresh installs need a Telegram integration with bot token. Paste token from BotFather, then save. This creates the integration if it does not exist, or updates existing one.",
      "manager.integrations.placeholder.integrationName": "Integration name",
      "manager.integrations.placeholder.botToken": "Telegram bot token (e.g. 123456:ABC...)",
      "manager.integrations.placeholder.chatId": "Your Telegram chat_id (e.g. 123456789)",
      "manager.integrations.placeholder.yourChatId": "Your chat_id: {{chatId}}",
      "manager.integrations.placeholder.recipientChatId": "Recipient chat_id",
      "manager.integrations.placeholder.messageText": "Message text",
      "manager.integrations.placeholder.template": "Write Telegram Markdown template here",
      "manager.integrations.defaultBotName": "Main Telegram Bot",
      "manager.integrations.saving": "Saving...",
      "manager.integrations.syncing": "Syncing...",
      "manager.integrations.sending": "Sending...",
      "manager.integrations.action.unlink": "Unlink",
      "manager.integrations.action.useMyChatId": "Use my chat_id",
      "manager.integrations.linkTelegramHelp1": "Enter your Telegram chat_id to receive booking notifications and use bot commands",
      "manager.integrations.linkTelegramHelp2": "To find your chat_id: open Telegram and message",
      "manager.integrations.linkTelegramHelp3": "- it will reply with your numeric ID.",
      "manager.integrations.sendTestHelp": "Send a test Telegram message to any chat_id to verify the integration works. Select a channel above first.",
      "manager.integrations.selectChannelToSend": "Select a channel above to enable sending.",
      "manager.integrations.noTelegramIntegrations": "No Telegram integrations found.",
      "manager.integrations.bookingTemplateHelp": "Telegram supports Markdown in this template. Placeholders:",
      "manager.integrations.selectTelegramFirst": "Select a Telegram channel above first.",
      "manager.integrations.selectedNotTelegram": "Selected channel is not Telegram.",
      "manager.integrations.result.savedChatId": "Saved! Your Telegram chat_id: {{chatId}}",
      "manager.integrations.result.telegramActive": "Telegram integration is active: {{name}} ({{id}})",
      "manager.integrations.result.savedTemplate": "Saved booking confirmation template.",
      "manager.integrations.error.enterToken": "Enter Telegram bot token.",
      "manager.integrations.error.selectTelegramFirst": "Create or select a Telegram integration first.",
      "manager.integrations.cleared": "cleared",
      "manager.branding.previewing": "Previewing {{mode}}",
      "manager.branding.previewMode.draft": "Draft preview",
      "manager.branding.previewMode.published": "Published preview",
      "manager.branding.action.up": "Up",
      "manager.branding.action.down": "Down",
      "manager.branding.action.rollbackToDraft": "Rollback To Draft",
      "manager.branding.publishHint": "Publish includes unsaved local changes (draft is auto-saved first).",
      "manager.branding.panel.brandKit": "Brand Kit",
      "manager.branding.panel.layout": "Layout & Components",
      "manager.branding.panel.media": "Media Library",
      "manager.branding.panel.content": "Content",
      "manager.branding.panel.publish": "Preview & Publish",
      "manager.branding.panel.advanced": "Advanced",
      "manager.branding.tokens": "Tokens",
      "manager.branding.baseSize": "Base size",
      "manager.branding.sectionInspector": "Section Inspector",
      "manager.branding.noSectionSelected": "No section selected",
      "manager.branding.sectionVariant": "Section variant",
      "manager.branding.default": "Default",
      "manager.branding.header": "Header",
      "manager.branding.alignLeft": "Align Left",
      "manager.branding.alignCenter": "Align Center",
      "manager.branding.compactPadding": "Compact Padding",
      "manager.branding.mediumPadding": "Medium Padding",
      "manager.branding.largePadding": "Large Padding",
      "manager.branding.list": "List",
      "manager.branding.grid": "Grid",
      "manager.branding.cardsWithImages": "Cards With Images",
      "manager.branding.imageCover": "Image Cover",
      "manager.branding.imageContain": "Image Contain",
      "manager.branding.showDuration": "Show duration",
      "manager.branding.showPrice": "Show price",
      "manager.branding.pills": "Pills",
      "manager.branding.cardsWithPhotos": "Cards With Photos",
      "manager.branding.showPhotos": "Show photos",
      "manager.branding.timeSlots": "Time Slots",
      "manager.branding.outline": "Outline",
      "manager.branding.filled": "Filled",
      "manager.branding.small": "Small",
      "manager.branding.medium": "Medium",
      "manager.branding.stepper": "Stepper",
      "manager.branding.numbers": "Numbers",
      "manager.branding.dots": "Dots",
      "manager.branding.showLabels": "Show labels",
      "manager.branding.form": "Form",
      "manager.branding.smallRadius": "Small Radius",
      "manager.branding.mediumRadius": "Medium Radius",
      "manager.branding.largeRadius": "Large Radius",
      "manager.branding.heroMain": "Hero main: {{id}} | Aux photos: {{count}}",
      "manager.branding.mediaHint": "Filter by type to find assets faster. Main/Aux buttons update your draft.",
      "manager.branding.filter.all": "All",
      "manager.branding.filter.hero": "Hero",
      "manager.branding.filter.logo": "Logo",
      "manager.branding.filter.service": "Service",
      "manager.branding.filter.staff": "Staff",
      "manager.branding.altText": "Alt text",
      "manager.branding.mainHeroSelected": "Main Hero (Draft Selected)",
      "manager.branding.setMainHero": "Set As Main Hero (Draft)",
      "manager.branding.removeAux": "Remove Aux",
      "manager.branding.addAux": "Add Aux",
      "manager.branding.placeholder.headerTitle": "Header title",
      "manager.branding.placeholder.headerSubtitle": "Header subtitle",
      "manager.branding.placeholder.beforeYouArrive": "Before you arrive",
      "manager.branding.placeholder.publishNotes": "Publish notes (optional)",
      "manager.branding.noNotes": "No notes",
      "manager.branding.publishedVersion": "Published version: {{version}}",
      "manager.branding.draftUpdated": "Draft updated: {{value}}",
      "manager.clients.aria.editLocale": "Edit client locale",
      "manager.clients.aria.editBookingMode": "Edit client booking mode",
      "manager.clients.aria.newLocale": "New client locale",
      "manager.clients.aria.newBookingMode": "New client booking mode",
      "manager.clients.noContact": "No contact details",
      "manager.clients.riskPill": "Risk {{tier}} ({{score}})",
      "manager.clients.telegram.linked": "Telegram linked",
      "manager.clients.telegram.unlinked": "Telegram not linked",
      "manager.clients.localePill": "Locale {{locale}}",
      "manager.clients.stats": "Visits {{visits}} | Completed {{completed}} | No-show {{noShow}}",
      "manager.clients.action.restore": "Restore",
      "manager.clients.action.archive": "Archive",
      "manager.clients.riskSummary": "Score: {{score}} | Tier: {{tier}}",
      "manager.clients.noFactors": "No factors available.",
      "manager.clients.loadingConversation": "Loading conversation...",
      "manager.clients.noHistory": "No history yet.",
      "manager.clients.telegramLinkHint.before": "Telegram is not linked for this client. Ask them to send",
      "manager.clients.telegramLinkHint.andThen": "then",
      "manager.clients.telegramLinkHint.after": "to your bot. If they were linked before, you can still try sending and the server will attempt to recover chat ID from history.",
      "manager.clients.template.confirmReminder": "Confirm Reminder",
      "manager.clients.template.noShow": "No-show Follow-up",
      "manager.clients.template.reactivation": "Reactivation",
      "manager.clients.channel.telegram": "telegram",
      "manager.clients.channel.sms": "sms",
      "manager.clients.channel.email": "email",
      "manager.clients.attachment": "Attachment",
      "manager.clients.action.removeAttachment": "Remove attachment",
    },
  },
  es: {
    translation: {
      appTitle: "Salon OS",
      login: "Iniciar sesi\u00f3n",
      logout: "Cerrar sesi\u00f3n",
      language: "Idioma",
      dashboard: "Panel",
      calendar: "Calendario",
      clients: "Clientes",
      staff: "Personal",
      services: "Servicios",
      inventory: "Inventario",
      automation: "Automatizaci\u00f3n",
      integrations: "Integraciones",
      analytics: "Anal\u00edtica",
      settings: "Configuraci\u00f3n",
      loading: "Cargando...",
      save: "Guardar",
      refresh: "Actualizar",
      "manager.command": "Panel del gerente",
      "common.status": "Estado",
      "nav.dashboard": "Panel",
      "nav.calendar": "Calendario",
      "nav.clients": "Clientes",
      "nav.staff": "Personal",
      "nav.services": "Servicios",
      "nav.inventory": "Inventario",
      "nav.automation": "Automatizaci\u00f3n",
      "nav.integrations": "Integraciones",
      "nav.branding": "Marca",
      "nav.settings": "Configuraci\u00f3n",
      "locale.en": "Ingl\u00e9s",
      "locale.ru": "Ruso",
      "locale.es": "Espa\u00f1ol",
      "locale.de": "Alem\u00e1n",
      "locale.fa": "Persa",
      "manager.clients.intelligence": "Inteligencia de clientes",
      "manager.clients.title": "Clientes",
      "manager.clients.tab.active": "Activos",
      "manager.clients.tab.archived": "Archivados",
      "manager.clients.searchPlaceholder": "Buscar por nombre / tel\u00e9fono / email",
      "manager.clients.filter.risk": "Riesgo",
      "manager.clients.filter.telegram": "Telegram",
      "manager.clients.filter.all": "Todos",
      "manager.clients.filter.linked": "Vinculados",
      "manager.clients.filter.unlinked": "Sin vincular",
      "manager.clients.risk.minimal": "m\u00ednimo",
      "manager.clients.risk.low": "bajo",
      "manager.clients.risk.medium": "medio",
      "manager.clients.risk.high": "alto",
      "manager.clients.visibleCount": "{{count}} visibles",
      "manager.clients.listTitle": "Lista de clientes",
      "manager.clients.noClients": "No se encontraron clientes.",
      "manager.clients.addTitle": "Agregar cliente",
      "manager.clients.conversationTitle": "Conversaci\u00f3n del cliente",
      "manager.clients.selectHint": "Selecciona un cliente para revisar riesgo e historial de conversaci\u00f3n.",
      "manager.clients.notice.created": "Cliente creado.",
      "manager.clients.notice.updated": "Cliente actualizado.",
      "manager.clients.notice.archived": "Cliente archivado.",
      "manager.clients.notice.restored": "Cliente restaurado.",
      "manager.clients.notice.sent": "Mensaje enviado.",
      "manager.dashboard.ribbon.overline": "Centro de control del gerente",
      "manager.dashboard.ribbon.title": "Bienvenido de nuevo",
      "manager.dashboard.branchScope": "Alcance de sucursal",
      "manager.dashboard.allBranches": "Todas las sucursales",
      "manager.dashboard.kpi.todayAppointments": "Citas de hoy",
      "manager.dashboard.kpi.noShowRate": "Tasa de ausencias",
      "manager.dashboard.kpi.queuePending": "Cola pendiente",
      "manager.dashboard.kpi.lowStockAlerts": "Alertas de stock bajo",
      "manager.dashboard.queueFailed24h": "{{count}} fallidas en 24h",
      "manager.dashboard.noQueueFailures24h": "Sin fallos de cola en 24h",
      "manager.dashboard.oldestPendingAge": "Antiguedad maxima de cola pendiente: {{minutes}} min",
      "manager.dashboard.todayRhythm": "Ritmo de hoy",
      "manager.dashboard.liveStatusMix": "Mezcla en vivo por estado de reserva",
      "manager.dashboard.loadingRhythm": "Cargando ritmo...",
      "manager.dashboard.status.pending": "Pendiente {{count}}",
      "manager.dashboard.status.confirmed": "Confirmado {{count}}",
      "manager.dashboard.status.completed": "Completado {{count}}",
      "manager.dashboard.status.cancelled": "Cancelado {{count}}",
      "manager.dashboard.status.noShow": "Ausencia {{count}}",
      "manager.dashboard.upcomingHighRisk": "Proximas citas de alto riesgo",
      "manager.dashboard.defaultService": "Servicio",
      "manager.dashboard.withStaff": "con",
      "manager.dashboard.defaultStaff": "Personal",
      "manager.dashboard.noUpcomingHighRisk": "No hay proximas citas de alto riesgo.",
      "manager.dashboard.recommendations": "Recomendaciones",
      "manager.dashboard.topStaff30d": "Mejor personal (30d)",
      "manager.dashboard.loadingStaff": "Cargando rendimiento del personal...",
      "manager.dashboard.completed": "Completado: {{count}}",
      "manager.dashboard.noShowRate": "Tasa de ausencias: {{value}}%",
      "manager.dashboard.revenue": "Ingresos: ${{value}}",
      "manager.dashboard.noStaffData": "Todavia no hay datos de personal.",
      "manager.dashboard.reco.noShow.title": "La tendencia de ausencias esta elevada",
      "manager.dashboard.reco.noShow.body": "Revisa clientes de alto riesgo y activa recordatorios para citas de manana.",
      "manager.dashboard.reco.messaging.title": "Los fallos de mensajeria requieren atencion",
      "manager.dashboard.reco.messaging.body": "{{count}} mensaje(s) fallido(s) en las ultimas 24h.",
      "manager.dashboard.reco.inventory.title": "Riesgo de inventario detectado",
      "manager.dashboard.reco.inventory.body": "{{count}} articulo(s) estan en o por debajo del umbral.",
      "manager.dashboard.reco.upcoming.title": "Proximas reservas de alto riesgo",
      "manager.dashboard.reco.upcoming.body": "{{count}} cita(s) proximas estan en nivel de alto riesgo.",
      "manager.dashboard.reco.healthy.title": "Operaciones en buen estado",
      "manager.dashboard.reco.healthy.body": "Cola, ritmo de reservas e indicadores de riesgo estan en rango normal.",
      "manager.dashboard.reco.openClients": "Abrir clientes",
      "manager.dashboard.reco.openIntegrations": "Abrir integraciones",
      "manager.dashboard.reco.openInventory": "Abrir inventario",
      "manager.dashboard.reco.openCalendar": "Abrir calendario",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.edit": "Editar",
      "common.delete": "Eliminar",
      "common.active": "Activo",
      "common.enabled": "activo",
      "common.disabled": "inactivo",
      "manager.layout.tenantFallback": "Sal\u00f3n",
      "manager.layout.unknown": "desconocido",
      "manager.media.selectFromLibrary": "Seleccionar de la biblioteca",
      "manager.media.removePhoto": "Quitar foto",
      "manager.automation.title": "Automatizaci\u00f3n",
      "manager.automation.section.rules": "Reglas de recordatorio",
      "manager.automation.section.flags": "Flags de funciones",
      "manager.automation.action.addRule": "Agregar regla",
      "manager.automation.action.upsertFlag": "Guardar flag",
      "manager.automation.currentLocale": "Idioma actual: {{locale}}",
      "manager.calendar.title": "Operaciones del calendario",
      "manager.calendar.subtitle": "Prioriza acciones por riesgo, estado y ritmo.",
      "manager.calendar.ribbon.overline": "Modo de decisiones del calendario",
      "manager.calendar.branch": "Sucursal",
      "manager.calendar.allBranches": "Todas las sucursales",
      "manager.calendar.appointmentsTitle": "Citas ({{day}})",
      "manager.calendar.itemsCount": "{{count}} elemento(s)",
      "manager.calendar.unknownClient": "Cliente desconocido",
      "manager.calendar.defaultService": "Servicio",
      "manager.calendar.withStaff": "con",
      "manager.calendar.defaultStaff": "Personal",
      "manager.calendar.endsAt": "Termina {{time}}",
      "manager.calendar.status.all": "Todos los estados",
      "manager.calendar.status.pending_confirmation": "Pendiente de confirmaci\u00f3n",
      "manager.calendar.status.confirmed": "Confirmado",
      "manager.calendar.status.completed": "Completado",
      "manager.calendar.status.cancelled": "Cancelado",
      "manager.calendar.status.no_show": "Ausencia",
      "manager.calendar.action.confirm": "Confirmar",
      "manager.calendar.action.cancel": "Cancelar",
      "manager.calendar.action.complete": "Completar",
      "manager.calendar.action.no_show": "Ausencia",
      "manager.calendar.action.reschedule": "Reprogramar",
      "manager.calendar.noAppointments": "No hay citas para este filtro.",
      "manager.inventory.title": "Inventario",
      "manager.inventory.products": "Productos",
      "manager.inventory.createProduct": "Crear producto",
      "manager.inventory.placeholder.sku": "SKU",
      "manager.inventory.placeholder.name": "Nombre",
      "manager.inventory.placeholder.locationName": "Nombre de ubicaci\u00f3n",
      "manager.inventory.action.addProduct": "Agregar producto",
      "manager.inventory.stockLocations": "Ubicaciones de stock",
      "manager.inventory.action.addLocation": "Agregar ubicaci\u00f3n",
      "manager.services.title": "Cat\u00e1logo de servicios",
      "manager.services.addService": "Agregar servicio",
      "manager.services.placeholder.serviceName": "Nombre del servicio",
      "manager.services.action.createService": "Crear servicio",
      "manager.staff.title": "Personal y habilidades",
      "manager.staff.team": "Equipo",
      "manager.staff.unknownBranch": "Sucursal desconocida",
      "manager.staff.skillsValue": "Habilidades: {{value}}",
      "manager.staff.none": "ninguna",
      "manager.staff.addMember": "Agregar miembro del personal",
      "manager.staff.placeholder.fullName": "Nombre completo",
      "manager.staff.placeholder.skills": "habilidades separadas por comas",
      "manager.staff.action.addStaff": "Agregar personal",
      "manager.settings.title": "Configuraci\u00f3n",
      "manager.settings.tenantProfile": "Perfil del sal\u00f3n",
      "manager.settings.featureFlags": "Flags de funciones",
      "manager.settings.field.name": "Nombre",
      "manager.settings.field.slug": "Slug",
      "manager.settings.field.status": "Estado",
      "manager.settings.field.locale": "Idioma",
      "manager.settings.field.plan": "Plan",
      "manager.settings.notSet": "sin definir",
      "manager.settings.messagingStrategy": "Estrategia de mensajer\u00eda",
      "manager.settings.messagingStrategyHelp": "Configura modo Telegram-first u otros modos por canal para cada mercado.",
      "manager.settings.field.marketProfile": "Perfil de mercado",
      "manager.settings.field.primaryMessenger": "Mensajero principal",
      "manager.settings.field.messengerFirstMode": "Modo messenger-first",
      "manager.settings.marketProfile.default": "Predeterminado (canales mixtos)",
      "manager.settings.marketProfile.telegram_first": "Telegram-first",
      "manager.settings.marketProfile.whatsapp_first": "WhatsApp-first",
      "manager.settings.primaryMessenger.none": "Ninguno",
      "manager.settings.primaryMessenger.telegram": "Telegram",
      "manager.settings.primaryMessenger.whatsapp": "WhatsApp",
      "manager.settings.primaryMessenger.sms": "SMS",
      "manager.settings.primaryMessenger.email": "Email",
      "manager.settings.saveStrategy": "Guardar estrategia",
      "manager.settings.saving": "Guardando...",
      "manager.settings.strategySaved": "Estrategia guardada.",
      "manager.settings.saveFailed": "No se pudo guardar.",
      "manager.settings.channelCapabilities": "Capacidades por canal",
      "manager.settings.noCapabilities": "No hay capacidades disponibles.",
      "manager.settings.cap.managerApp": "App embebida para manager",
      "manager.settings.cap.clientApp": "App embebida para cliente",
      "manager.settings.cap.freeformOutbound": "Salida libre",
      "manager.settings.cap.templateOnlyOutbound": "Solo plantillas",
      "manager.settings.cap.deepLinks": "Enlaces profundos",
      "manager.settings.cap.identityLinking": "Vinculaci\u00f3n de identidad",
      "manager.integrations.title": "Integraciones",
      "manager.integrations.activateBot": "Activar bot de Telegram",
      "manager.integrations.action.saveBot": "Guardar bot de Telegram",
      "manager.integrations.action.syncWebhook": "Sincronizar webhook",
      "manager.integrations.connectedChannels": "Canales conectados",
      "manager.integrations.linkTelegram": "Vincular tu Telegram",
      "manager.integrations.currentlyLinked": "Vinculado actualmente:",
      "manager.integrations.sendTestMessage": "Enviar mensaje de prueba",
      "manager.integrations.action.sendTest": "Enviar prueba",
      "manager.integrations.noResultYet": "Sin resultados todav\u00eda.",
      "manager.integrations.bookingTemplateTitle": "Plantilla de confirmaci\u00f3n de reserva",
      "manager.integrations.action.saveTemplate": "Guardar plantilla",
      "manager.integrations.action.resetDefault": "Restablecer por defecto",
      "manager.branding.title": "Estudio de marca",
      "manager.branding.unsaved": "Cambios sin guardar",
      "manager.branding.saved": "Guardado",
      "manager.branding.action.saveDraft": "Guardar borrador",
      "manager.branding.action.publish": "Publicar",
      "manager.branding.pageSections": "Secciones de p\u00e1gina",
      "manager.branding.mediaLibrary": "Biblioteca de medios",
      "manager.branding.search": "Buscar",
      "manager.branding.publicContent": "Contenido p\u00fablico",
      "manager.branding.versionHistory": "Historial de versiones",
      "manager.branding.accessibilitySafety": "Accesibilidad y seguridad",
      "manager.branding.noWarnings": "Sin advertencias.",
      "manager.branding.warning.contrastPrimary": "Contraste bajo: texto sobre primario",
      "manager.branding.warning.contrastSurface": "Contraste bajo: texto sobre superficie",
      "manager.branding.warning.missingAlt": "{{count}} elemento(s) sin texto alternativo",
      "manager.clients.placeholder.fullName": "Nombre completo",
      "manager.clients.placeholder.phone": "Tel\u00e9fono",
      "manager.clients.placeholder.email": "Email",
      "manager.clients.placeholder.message": "Escribe un mensaje usando markdown: **bold**, *italic*, [link](https://...)",
      "manager.clients.noBranch": "Sin sucursal",
      "manager.clients.bookingMode.web_page": "P\u00e1gina web",
      "manager.clients.bookingMode.web_app": "Aplicaci\u00f3n web",
      "manager.clients.bookingMode.both": "Ambos",
      "manager.clients.action.saveClient": "Guardar cliente",
      "manager.clients.sendMessage": "Enviar mensaje",
      "manager.clients.action.send": "Enviar",
      "manager.clients.preview": "Vista previa",
      "manager.calendar.riskPill": "risk: {{tier}}",
      "manager.calendar.prompt.reschedule": "Enter new start time in ISO format (e.g. 2026-02-20T10:00:00Z)",
      "manager.inventory.skuValue": "SKU {{sku}}",
      "manager.inventory.thresholdValue": "Low stock threshold {{count}}",
      "manager.integrations.activateBotHelp": "Fresh installs need a Telegram integration with bot token. Paste token from BotFather, then save. This creates the integration if it does not exist, or updates existing one.",
      "manager.integrations.placeholder.integrationName": "Integration name",
      "manager.integrations.placeholder.botToken": "Telegram bot token (e.g. 123456:ABC...)",
      "manager.integrations.placeholder.chatId": "Your Telegram chat_id (e.g. 123456789)",
      "manager.integrations.placeholder.yourChatId": "Your chat_id: {{chatId}}",
      "manager.integrations.placeholder.recipientChatId": "Recipient chat_id",
      "manager.integrations.placeholder.messageText": "Message text",
      "manager.integrations.placeholder.template": "Write Telegram Markdown template here",
      "manager.integrations.defaultBotName": "Main Telegram Bot",
      "manager.integrations.saving": "Saving...",
      "manager.integrations.syncing": "Syncing...",
      "manager.integrations.sending": "Sending...",
      "manager.integrations.action.unlink": "Unlink",
      "manager.integrations.action.useMyChatId": "Use my chat_id",
      "manager.integrations.linkTelegramHelp1": "Enter your Telegram chat_id to receive booking notifications and use bot commands",
      "manager.integrations.linkTelegramHelp2": "To find your chat_id: open Telegram and message",
      "manager.integrations.linkTelegramHelp3": "- it will reply with your numeric ID.",
      "manager.integrations.sendTestHelp": "Send a test Telegram message to any chat_id to verify the integration works. Select a channel above first.",
      "manager.integrations.selectChannelToSend": "Select a channel above to enable sending.",
      "manager.integrations.noTelegramIntegrations": "No Telegram integrations found.",
      "manager.integrations.bookingTemplateHelp": "Telegram supports Markdown in this template. Placeholders:",
      "manager.integrations.selectTelegramFirst": "Select a Telegram channel above first.",
      "manager.integrations.selectedNotTelegram": "Selected channel is not Telegram.",
      "manager.integrations.result.savedChatId": "Saved! Your Telegram chat_id: {{chatId}}",
      "manager.integrations.result.telegramActive": "Telegram integration is active: {{name}} ({{id}})",
      "manager.integrations.result.savedTemplate": "Saved booking confirmation template.",
      "manager.integrations.error.enterToken": "Enter Telegram bot token.",
      "manager.integrations.error.selectTelegramFirst": "Create or select a Telegram integration first.",
      "manager.integrations.cleared": "cleared",
      "manager.branding.previewing": "Previewing {{mode}}",
      "manager.branding.previewMode.draft": "Draft preview",
      "manager.branding.previewMode.published": "Published preview",
      "manager.branding.action.up": "Up",
      "manager.branding.action.down": "Down",
      "manager.branding.action.rollbackToDraft": "Rollback To Draft",
      "manager.branding.publishHint": "Publish includes unsaved local changes (draft is auto-saved first).",
      "manager.branding.panel.brandKit": "Brand Kit",
      "manager.branding.panel.layout": "Layout & Components",
      "manager.branding.panel.media": "Media Library",
      "manager.branding.panel.content": "Content",
      "manager.branding.panel.publish": "Preview & Publish",
      "manager.branding.panel.advanced": "Advanced",
      "manager.branding.tokens": "Tokens",
      "manager.branding.baseSize": "Base size",
      "manager.branding.sectionInspector": "Section Inspector",
      "manager.branding.noSectionSelected": "No section selected",
      "manager.branding.sectionVariant": "Section variant",
      "manager.branding.default": "Default",
      "manager.branding.header": "Header",
      "manager.branding.alignLeft": "Align Left",
      "manager.branding.alignCenter": "Align Center",
      "manager.branding.compactPadding": "Compact Padding",
      "manager.branding.mediumPadding": "Medium Padding",
      "manager.branding.largePadding": "Large Padding",
      "manager.branding.list": "List",
      "manager.branding.grid": "Grid",
      "manager.branding.cardsWithImages": "Cards With Images",
      "manager.branding.imageCover": "Image Cover",
      "manager.branding.imageContain": "Image Contain",
      "manager.branding.showDuration": "Show duration",
      "manager.branding.showPrice": "Show price",
      "manager.branding.pills": "Pills",
      "manager.branding.cardsWithPhotos": "Cards With Photos",
      "manager.branding.showPhotos": "Show photos",
      "manager.branding.timeSlots": "Time Slots",
      "manager.branding.outline": "Outline",
      "manager.branding.filled": "Filled",
      "manager.branding.small": "Small",
      "manager.branding.medium": "Medium",
      "manager.branding.stepper": "Stepper",
      "manager.branding.numbers": "Numbers",
      "manager.branding.dots": "Dots",
      "manager.branding.showLabels": "Show labels",
      "manager.branding.form": "Form",
      "manager.branding.smallRadius": "Small Radius",
      "manager.branding.mediumRadius": "Medium Radius",
      "manager.branding.largeRadius": "Large Radius",
      "manager.branding.heroMain": "Hero main: {{id}} | Aux photos: {{count}}",
      "manager.branding.mediaHint": "Filter by type to find assets faster. Main/Aux buttons update your draft.",
      "manager.branding.filter.all": "All",
      "manager.branding.filter.hero": "Hero",
      "manager.branding.filter.logo": "Logo",
      "manager.branding.filter.service": "Service",
      "manager.branding.filter.staff": "Staff",
      "manager.branding.altText": "Alt text",
      "manager.branding.mainHeroSelected": "Main Hero (Draft Selected)",
      "manager.branding.setMainHero": "Set As Main Hero (Draft)",
      "manager.branding.removeAux": "Remove Aux",
      "manager.branding.addAux": "Add Aux",
      "manager.branding.placeholder.headerTitle": "Header title",
      "manager.branding.placeholder.headerSubtitle": "Header subtitle",
      "manager.branding.placeholder.beforeYouArrive": "Before you arrive",
      "manager.branding.placeholder.publishNotes": "Publish notes (optional)",
      "manager.branding.noNotes": "No notes",
      "manager.branding.publishedVersion": "Published version: {{version}}",
      "manager.branding.draftUpdated": "Draft updated: {{value}}",
      "manager.clients.aria.editLocale": "Edit client locale",
      "manager.clients.aria.editBookingMode": "Edit client booking mode",
      "manager.clients.aria.newLocale": "New client locale",
      "manager.clients.aria.newBookingMode": "New client booking mode",
      "manager.clients.noContact": "No contact details",
      "manager.clients.riskPill": "Risk {{tier}} ({{score}})",
      "manager.clients.telegram.linked": "Telegram linked",
      "manager.clients.telegram.unlinked": "Telegram not linked",
      "manager.clients.localePill": "Locale {{locale}}",
      "manager.clients.stats": "Visits {{visits}} | Completed {{completed}} | No-show {{noShow}}",
      "manager.clients.action.restore": "Restore",
      "manager.clients.action.archive": "Archive",
      "manager.clients.riskSummary": "Score: {{score}} | Tier: {{tier}}",
      "manager.clients.noFactors": "No factors available.",
      "manager.clients.loadingConversation": "Loading conversation...",
      "manager.clients.noHistory": "No history yet.",
      "manager.clients.telegramLinkHint.before": "Telegram is not linked for this client. Ask them to send",
      "manager.clients.telegramLinkHint.andThen": "then",
      "manager.clients.telegramLinkHint.after": "to your bot. If they were linked before, you can still try sending and the server will attempt to recover chat ID from history.",
      "manager.clients.template.confirmReminder": "Confirm Reminder",
      "manager.clients.template.noShow": "No-show Follow-up",
      "manager.clients.template.reactivation": "Reactivation",
      "manager.clients.channel.telegram": "telegram",
      "manager.clients.channel.sms": "sms",
      "manager.clients.channel.email": "email",
      "manager.clients.attachment": "Attachment",
      "manager.clients.action.removeAttachment": "Remove attachment",
    },
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LOCALES,
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

const featureTranslations = {
  en: {
    "manager.layout.openNavigation": "Open navigation",
    "manager.dashboard.kpi.waitlistOpen": "Open Waitlist",
    "manager.dashboard.waitlistBooked7d": "Booked from waitlist (7d): {{count}}",
    "manager.dashboard.reco.waitlist.title": "Open waitlist demand",
    "manager.dashboard.reco.waitlist.body": "{{count}} client(s) are waiting for slots.",
    "manager.calendar.waitlist.title": "Waitlist ({{day}})",
    "manager.calendar.waitlist.count": "{{count}} item(s)",
    "manager.calendar.waitlist.status.open": "open",
    "manager.calendar.waitlist.status.contacted": "contacted",
    "manager.calendar.waitlist.status.booked": "booked",
    "manager.calendar.waitlist.status.closed": "closed",
    "manager.calendar.waitlist.action.copyLink": "Copy booking link",
    "manager.calendar.waitlist.action.contacted": "Mark contacted",
    "manager.calendar.waitlist.action.close": "Close",
    "manager.calendar.waitlist.empty": "No waitlist entries for this day.",
    "manager.calendar.waitlist.copied": "Booking link copied.",
    "manager.calendar.tab.today": "Today",
    "manager.calendar.tab.day": "Day",
    "manager.calendar.tab.queue": "Queue",
    "manager.calendar.tab.waitlist": "Waitlist",
    "manager.calendar.queue.title": "Queue (next 7 days)",
    "manager.calendar.queue.subtitle": "Needs action across days",
    "manager.calendar.search": "Quick search",
    "manager.calendar.searchPlaceholder": "Customer, phone, service",
    "manager.calendar.staff": "Staff",
    "manager.calendar.staffAll": "All staff",
    "manager.calendar.refresh": "Refresh",
    "manager.calendar.autorefresh": "Auto-refresh every 30s",
    "manager.calendar.moreActions": "More",
    "manager.calendar.viewDetails": "View details",
    "manager.calendar.retry": "Retry",
    "manager.calendar.copyRequestId": "Copy Request ID",
    "manager.calendar.confirmPrompt": "Confirm this action?",
    "manager.calendar.reason.note": "Optional note",
    "manager.calendar.dialog.close": "Close",
    "manager.calendar.dialog.confirm": "Confirm",
    "manager.calendar.dialog.processing": "Processing...",
    "manager.calendar.reschedule.apply": "Apply",
    "manager.calendar.reschedule.empty": "No slots available for this day.",
    "manager.calendar.reschedule.slotGone": "Slot no longer available",
    "manager.calendar.detail.title": "Appointment detail",
    "manager.calendar.detail.close": "Close",
    "manager.calendar.detail.schedule": "Schedule",
    "manager.calendar.detail.service": "Service",
    "manager.calendar.detail.staff": "Staff",
    "manager.calendar.detail.branch": "Branch",
    "manager.calendar.detail.contact": "Contact",
    "manager.calendar.detail.noPhone": "No phone",
    "manager.calendar.detail.notes": "Notes",
    "manager.calendar.detail.timeline": "Timeline",
    "manager.calendar.detail.timelineEmpty": "No timeline events yet.",
    "client.booking.heroTitle": "Book your visit",
    "client.booking.heroSubtitle": "Select your service and preferred time.",
    "client.booking.galleryAlt": "Gallery",
    "client.booking.howItWorks": "How it works",
    "client.booking.howItWorksBody": "Choose service, pick a specialist and confirm your appointment in less than a minute.",
    "client.booking.sessionTimer": "Session reservation timer",
    "client.booking.sessionLeft": "{{time}} left",
    "client.booking.sessionExpired": "expired",
    "client.booking.sessionExpiredError": "Your booking session expired. Please refresh and start again.",
    "client.booking.nameRequired": "Please enter your name.",
    "client.booking.footerThanks": "Thank you for booking with us.",
    "client.booking.step.services.title": "Choose a service",
    "client.booking.step.time.title": "Pick date & time",
    "client.booking.durationMinutes": "{{count}} min",
    "client.booking.anySpecialist": "Any specialist",
    "client.booking.noSlots": "No available times",
    "client.booking.noSlotsHint": "Try another date or join the waitlist.",
    "client.waitlist.successTitle": "You are on the waitlist",
    "client.waitlist.successHint": "We will contact you when a matching slot opens.",
    "client.waitlist.name": "Your name",
    "client.waitlist.phone": "Phone",
    "client.waitlist.email": "Email (optional)",
    "client.waitlist.notes": "Notes (optional)",
    "client.waitlist.submitting": "Saving...",
    "client.waitlist.join": "Join waitlist",
    "client.booking.group.morning": "Morning",
    "client.booking.group.afternoon": "Afternoon",
    "client.booking.group.evening": "Evening",
    "client.booking.today": "Today",
    "client.booking.defaultStaff": "Staff",
    "client.booking.whyRecommended": "Why recommended",
    "client.booking.continueWithSlot": "Continue with {{service}} at {{time}}",
    "client.booking.withStaff": "with",
    "client.booking.factor.repeatClient": "Repeat client fit",
    "client.booking.factor.gapFill": "Gap fill optimization",
    "client.booking.factor.loadBalance": "Load balance",
    "client.booking.factor.timeOfDay": "Time of day",
    "common.continue": "Continue",
    "client.actions.confirmTitle": "Confirm Appointment",
    "client.actions.manageTitle": "Manage Appointment",
    "client.actions.loading": "Loading details...",
    "client.actions.defaultClient": "Client",
    "client.actions.defaultService": "Service",
    "client.actions.withStaff": "with",
    "client.actions.defaultStaff": "Staff",
    "client.actions.tokenAction": "Token action",
    "client.actions.apply": "Apply action",
    "client.pwa.title": "Install booking app",
    "client.pwa.body": "Add this booking page to your home screen for faster returns.",
    "client.pwa.install": "Install",
    "client.pwa.installing": "Installing...",
    "client.pwa.dismiss": "Not now",
  },
  fa: {
    "manager.layout.openNavigation": "باز کردن ناوبری",
    "manager.dashboard.kpi.waitlistOpen": "لیست انتظار باز",
    "manager.dashboard.waitlistBooked7d": "رزرو شده از لیست انتظار (7 روز): {{count}}",
    "manager.dashboard.reco.waitlist.title": "تقاضای باز لیست انتظار",
    "manager.dashboard.reco.waitlist.body": "{{count}} مشتری منتظر نوبت خالی هستند.",
    "manager.calendar.waitlist.title": "لیست انتظار ({{day}})",
    "manager.calendar.waitlist.count": "{{count}} مورد",
    "manager.calendar.waitlist.status.open": "باز",
    "manager.calendar.waitlist.status.contacted": "تماس گرفته شد",
    "manager.calendar.waitlist.status.booked": "رزرو شد",
    "manager.calendar.waitlist.status.closed": "بسته",
    "manager.calendar.waitlist.action.copyLink": "کپی لینک رزرو",
    "manager.calendar.waitlist.action.contacted": "علامت گذاری تماس شده",
    "manager.calendar.waitlist.action.close": "بستن",
    "manager.calendar.waitlist.empty": "برای این روز موردی در لیست انتظار وجود ندارد.",
    "manager.calendar.waitlist.copied": "لینک رزرو کپی شد.",
    "manager.calendar.tab.today": "امروز",
    "manager.calendar.tab.day": "روز",
    "manager.calendar.tab.queue": "صف",
    "manager.calendar.tab.waitlist": "لیست انتظار",
    "manager.calendar.queue.title": "صف (7 روز آینده)",
    "manager.calendar.queue.subtitle": "نیازمند اقدام در روزهای آینده",
    "manager.calendar.search": "جستجوی سریع",
    "manager.calendar.searchPlaceholder": "مشتری، تلفن، خدمت",
    "manager.calendar.staff": "پرسنل",
    "manager.calendar.staffAll": "همه پرسنل",
    "manager.calendar.refresh": "بروزرسانی",
    "manager.calendar.autorefresh": "بروزرسانی خودکار هر 30 ثانیه",
    "manager.calendar.moreActions": "بیشتر",
    "manager.calendar.viewDetails": "مشاهده جزئیات",
    "manager.calendar.retry": "تلاش مجدد",
    "manager.calendar.copyRequestId": "کپی شناسه درخواست",
    "manager.calendar.confirmPrompt": "این اقدام تایید شود؟",
    "manager.calendar.reason.note": "یادداشت (اختیاری)",
    "manager.calendar.dialog.close": "بستن",
    "manager.calendar.dialog.confirm": "تایید",
    "manager.calendar.dialog.processing": "در حال پردازش...",
    "manager.calendar.reschedule.apply": "اعمال",
    "manager.calendar.reschedule.empty": "برای این روز زمان خالی وجود ندارد.",
    "manager.calendar.reschedule.slotGone": "این زمان دیگر در دسترس نیست",
    "manager.calendar.detail.title": "جزئیات نوبت",
    "manager.calendar.detail.close": "بستن",
    "manager.calendar.detail.schedule": "زمان بندی",
    "manager.calendar.detail.service": "خدمت",
    "manager.calendar.detail.staff": "پرسنل",
    "manager.calendar.detail.branch": "شعبه",
    "manager.calendar.detail.contact": "اطلاعات تماس",
    "manager.calendar.detail.noPhone": "شماره تلفن ندارد",
    "manager.calendar.detail.notes": "یادداشت ها",
    "manager.calendar.detail.timeline": "خط زمانی",
    "manager.calendar.detail.timelineEmpty": "هنوز رویدادی ثبت نشده است.",
    "client.booking.heroTitle": "رزرو نوبت",
    "client.booking.heroSubtitle": "خدمت و زمان دلخواه خود را انتخاب کنید.",
    "client.booking.galleryAlt": "گالری",
    "client.booking.howItWorks": "نحوه کار",
    "client.booking.howItWorksBody": "خدمت را انتخاب کنید، متخصص را برگزینید و در کمتر از یک دقیقه نوبت خود را تایید کنید.",
    "client.booking.sessionTimer": "زمان سنج رزرو",
    "client.booking.sessionLeft": "{{time}} باقی مانده",
    "client.booking.sessionExpired": "منقضی شد",
    "client.booking.sessionExpiredError": "جلسه رزرو شما منقضی شد. لطفا صفحه را تازه کنید و دوباره شروع کنید.",
    "client.booking.nameRequired": "لطفا نام خود را وارد کنید.",
    "client.booking.footerThanks": "از رزرو شما سپاسگزاریم.",
    "client.booking.step.services.title": "یک خدمت انتخاب کنید",
    "client.booking.step.time.title": "تاریخ و ساعت را انتخاب کنید",
    "client.booking.durationMinutes": "{{count}} دقیقه",
    "client.booking.anySpecialist": "هر متخصص",
    "client.booking.noSlots": "زمان خالی موجود نیست",
    "client.booking.noSlotsHint": "تاریخ دیگری را امتحان کنید یا به لیست انتظار بپیوندید.",
    "client.waitlist.successTitle": "شما در لیست انتظار هستید",
    "client.waitlist.successHint": "وقتی زمان مناسب باز شود با شما تماس می گیریم.",
    "client.waitlist.name": "نام شما",
    "client.waitlist.phone": "تلفن",
    "client.waitlist.email": "ایمیل (اختیاری)",
    "client.waitlist.notes": "یادداشت (اختیاری)",
    "client.waitlist.submitting": "در حال ذخیره...",
    "client.waitlist.join": "پیوستن به لیست انتظار",
    "client.booking.group.morning": "صبح",
    "client.booking.group.afternoon": "بعدازظهر",
    "client.booking.group.evening": "عصر",
    "client.booking.today": "امروز",
    "client.booking.defaultStaff": "کارکنان",
    "client.booking.whyRecommended": "چرا توصیه می شود",
    "client.booking.continueWithSlot": "ادامه با {{service}} در {{time}}",
    "client.booking.withStaff": "با",
    "client.booking.factor.repeatClient": "تکرار تناسب مشتری",
    "client.booking.factor.gapFill": "بهینه سازی پر کردن شکاف",
    "client.booking.factor.loadBalance": "تعادل بار",
    "client.booking.factor.timeOfDay": "زمان روز",
    "common.continue": "ادامه",
    "client.actions.confirmTitle": "تایید نوبت",
    "client.actions.manageTitle": "مدیریت نوبت",
    "client.actions.loading": "در حال بارگذاری جزئیات...",
    "client.actions.defaultClient": "مشتری",
    "client.actions.defaultService": "خدمت",
    "client.actions.withStaff": "با",
    "client.actions.defaultStaff": "متخصص",
    "client.actions.tokenAction": "اقدام توکن",
    "client.actions.apply": "اعمال اقدام",
    "client.pwa.title": "نصب برنامه رزرو",
    "client.pwa.body": "این صفحه رزرو را به صفحه اصلی خود اضافه کنید تا دفعه بعد سریع تر برگردید.",
    "client.pwa.install": "نصب",
    "client.pwa.installing": "در حال نصب...",
    "client.pwa.dismiss": "فعلا نه",
  },
  de: {
    "manager.layout.openNavigation": "Navigation öffnen",
    "manager.dashboard.kpi.waitlistOpen": "Warteliste öffnen",
    "manager.dashboard.waitlistBooked7d": "Gebucht von der Warteliste (7 Tage): {{count}}",
    "manager.dashboard.reco.waitlist.title": "Offene Wartelistennachfrage",
    "manager.dashboard.reco.waitlist.body": "{{count}} Client(s) warten auf Slots.",
    "manager.calendar.waitlist.title": "Warteliste ({{day}})",
    "manager.calendar.waitlist.count": "{{count}} Artikel",
    "manager.calendar.waitlist.status.open": "offen",
    "manager.calendar.waitlist.status.contacted": "kontaktiert",
    "manager.calendar.waitlist.status.booked": "gebucht",
    "manager.calendar.waitlist.status.closed": "geschlossen",
    "manager.calendar.waitlist.action.copyLink": "Buchungslink kopieren",
    "manager.calendar.waitlist.action.contacted": "Mark kontaktiert",
    "manager.calendar.waitlist.action.close": "Schließen",
    "manager.calendar.waitlist.empty": "Für diesen Tag gibt es keine Wartelisteneinträge.",
    "manager.calendar.waitlist.copied": "Buchungslink kopiert.",
    "manager.calendar.tab.today": "Heute",
    "manager.calendar.tab.day": "Tag",
    "manager.calendar.tab.queue": "Queue",
    "manager.calendar.tab.waitlist": "Warteliste",
    "manager.calendar.queue.title": "Queue (nächste 7 Tage)",
    "manager.calendar.queue.subtitle": "Aktionsbedarf über mehrere Tage",
    "manager.calendar.search": "Schnellsuche",
    "manager.calendar.searchPlaceholder": "Kunde, Telefon, Leistung",
    "manager.calendar.staff": "Personal",
    "manager.calendar.staffAll": "Gesamtes Personal",
    "manager.calendar.refresh": "Aktualisieren",
    "manager.calendar.autorefresh": "Auto-Aktualisierung alle 30s",
    "manager.calendar.moreActions": "Mehr",
    "manager.calendar.viewDetails": "Details anzeigen",
    "manager.calendar.retry": "Erneut versuchen",
    "manager.calendar.copyRequestId": "Request-ID kopieren",
    "manager.calendar.confirmPrompt": "Diese Aktion best?tigen?",
    "manager.calendar.reason.note": "Optionale Notiz",
    "manager.calendar.dialog.close": "Schließen",
    "manager.calendar.dialog.confirm": "Bestätigen",
    "manager.calendar.dialog.processing": "Wird verarbeitet...",
    "manager.calendar.reschedule.apply": "Anwenden",
    "manager.calendar.reschedule.empty": "Für diesen Tag sind keine Slots verfügbar.",
    "manager.calendar.reschedule.slotGone": "Slot ist nicht mehr verfügbar",
    "manager.calendar.detail.title": "Termindetails",
    "manager.calendar.detail.close": "Schließen",
    "manager.calendar.detail.schedule": "Zeitplan",
    "manager.calendar.detail.service": "Leistung",
    "manager.calendar.detail.staff": "Personal",
    "manager.calendar.detail.branch": "Filiale",
    "manager.calendar.detail.contact": "Kontakt",
    "manager.calendar.detail.noPhone": "Kein Telefon",
    "manager.calendar.detail.notes": "Notizen",
    "manager.calendar.detail.timeline": "Verlauf",
    "manager.calendar.detail.timelineEmpty": "Noch keine Verlaufseinträge.",
    "client.booking.heroTitle": "Termin buchen",
    "client.booking.heroSubtitle": "Wählen Sie Ihre Leistung und Wunschzeit.",
    "client.booking.galleryAlt": "Galerie",
    "client.booking.howItWorks": "So funktioniert es",
    "client.booking.howItWorksBody": "Leistung wählen, Spezialist auswählen und Termin in weniger als einer Minute bestätigen.",
    "client.booking.sessionTimer": "Reservierungs-Timer",
    "client.booking.sessionLeft": "{{time}} übrig",
    "client.booking.sessionExpired": "abgelaufen",
    "client.booking.sessionExpiredError": "Ihre Buchungssitzung ist abgelaufen. Bitte aktualisieren Sie die Seite und starten Sie erneut.",
    "client.booking.nameRequired": "Bitte geben Sie Ihren Namen ein.",
    "client.booking.footerThanks": "Vielen Dank, dass Sie bei uns gebucht haben.",
    "client.booking.step.services.title": "Leistung wählen",
    "client.booking.step.time.title": "Datum & Uhrzeit wählen",
    "client.booking.durationMinutes": "{{count}} Min.",
    "client.booking.anySpecialist": "Beliebiger Spezialist",
    "client.booking.noSlots": "Keine verfügbaren Zeiten",
    "client.booking.noSlotsHint": "Versuchen Sie einen anderen Tag oder tragen Sie sich in die Warteliste ein.",
    "client.waitlist.successTitle": "Sie stehen auf der Warteliste",
    "client.waitlist.successHint": "Wir kontaktieren Sie, wenn ein passender Termin frei wird.",
    "client.waitlist.name": "Ihr Name",
    "client.waitlist.phone": "Telefon",
    "client.waitlist.email": "E-Mail (optional)",
    "client.waitlist.notes": "Notizen (optional)",
    "client.waitlist.submitting": "Speichern...",
    "client.waitlist.join": "Zur Warteliste",
    "client.booking.group.morning": "Vormittag",
    "client.booking.group.afternoon": "Nachmittag",
    "client.booking.group.evening": "Abend",
    "client.booking.today": "Heute",
    "client.booking.defaultStaff": "Personal",
    "client.booking.whyRecommended": "Warum empfohlen",
    "client.booking.continueWithSlot": "Weiter mit {{service}} bei {{time}}",
    "client.booking.withStaff": "mit",
    "client.booking.factor.repeatClient": "Wiederholen Sie die Kundenanpassung",
    "client.booking.factor.gapFill": "Optimierung der Lückenfüllung",
    "client.booking.factor.loadBalance": "Lastausgleich",
    "client.booking.factor.timeOfDay": "Uhrzeit",
    "common.continue": "Weiter",
    "client.actions.confirmTitle": "Termin bestätigen",
    "client.actions.manageTitle": "Termin verwalten",
    "client.actions.loading": "Details werden geladen...",
    "client.actions.defaultClient": "Kunde",
    "client.actions.defaultService": "Leistung",
    "client.actions.withStaff": "mit",
    "client.actions.defaultStaff": "Mitarbeiter",
    "client.actions.tokenAction": "Token-Aktion",
    "client.actions.apply": "Aktion ausführen",
    "client.pwa.title": "Buchungs-App installieren",
    "client.pwa.body": "Fügen Sie diese Buchungsseite Ihrem Startbildschirm hinzu, um sie künftig schneller zu öffnen.",
    "client.pwa.install": "Installieren",
    "client.pwa.installing": "Installation läuft...",
    "client.pwa.dismiss": "Nicht jetzt",
  },
  ru: {
    "manager.layout.openNavigation": "Открыть навигацию",
    "manager.dashboard.kpi.waitlistOpen": "Открытый лист ожидания",
    "manager.dashboard.waitlistBooked7d": "Записаны из листа ожидания (7д): {{count}}",
    "manager.dashboard.reco.waitlist.title": "Спрос в листе ожидания",
    "manager.dashboard.reco.waitlist.body": "{{count}} клиент(ов) ждут свободный слот.",
    "manager.calendar.waitlist.title": "Лист ожидания ({{day}})",
    "manager.calendar.waitlist.count": "{{count}} шт.",
    "manager.calendar.waitlist.status.open": "открыт",
    "manager.calendar.waitlist.status.contacted": "связались",
    "manager.calendar.waitlist.status.booked": "записан",
    "manager.calendar.waitlist.status.closed": "закрыт",
    "manager.calendar.waitlist.action.copyLink": "Копировать ссылку",
    "manager.calendar.waitlist.action.contacted": "Отметить: связались",
    "manager.calendar.waitlist.action.close": "Закрыть",
    "manager.calendar.waitlist.empty": "На этот день записей в листе ожидания нет.",
    "manager.calendar.waitlist.copied": "Ссылка на запись скопирована.",
    "manager.calendar.tab.today": "Сегодня",
    "manager.calendar.tab.day": "День",
    "manager.calendar.tab.queue": "Очередь",
    "manager.calendar.tab.waitlist": "Лист ожидания",
    "manager.calendar.queue.title": "Очередь (следующие 7 дней)",
    "manager.calendar.queue.subtitle": "Требуют действий в ближайшие дни",
    "manager.calendar.search": "Быстрый поиск",
    "manager.calendar.searchPlaceholder": "Клиент, телефон, услуга",
    "manager.calendar.staff": "Сотрудник",
    "manager.calendar.staffAll": "Все сотрудники",
    "manager.calendar.refresh": "Обновить",
    "manager.calendar.autorefresh": "Автообновление каждые 30 сек",
    "manager.calendar.moreActions": "Еще",
    "manager.calendar.viewDetails": "Подробнее",
    "manager.calendar.retry": "Повторить",
    "manager.calendar.copyRequestId": "Копировать ID запроса",
    "manager.calendar.confirmPrompt": "Подтвердить действие?",
    "manager.calendar.reason.note": "Заметка (необязательно)",
    "manager.calendar.dialog.close": "Закрыть",
    "manager.calendar.dialog.confirm": "Подтвердить",
    "manager.calendar.dialog.processing": "Обработка...",
    "manager.calendar.reschedule.apply": "Применить",
    "manager.calendar.reschedule.empty": "На этот день нет доступных слотов.",
    "manager.calendar.reschedule.slotGone": "Слот больше недоступен",
    "manager.calendar.detail.title": "Детали записи",
    "manager.calendar.detail.close": "Закрыть",
    "manager.calendar.detail.schedule": "Расписание",
    "manager.calendar.detail.service": "Услуга",
    "manager.calendar.detail.staff": "Сотрудник",
    "manager.calendar.detail.branch": "Филиал",
    "manager.calendar.detail.contact": "Контакт",
    "manager.calendar.detail.noPhone": "Телефон не указан",
    "manager.calendar.detail.notes": "Заметки",
    "manager.calendar.detail.timeline": "История",
    "manager.calendar.detail.timelineEmpty": "Событий пока нет.",
    "client.booking.heroTitle": "Запишитесь на визит",
    "client.booking.heroSubtitle": "Выберите услугу и удобное время.",
    "client.booking.galleryAlt": "Галерея",
    "client.booking.howItWorks": "Как это работает",
    "client.booking.howItWorksBody": "Выберите услугу, специалиста и подтвердите запись меньше чем за минуту.",
    "client.booking.sessionTimer": "Таймер бронирования",
    "client.booking.sessionLeft": "Осталось {{time}}",
    "client.booking.sessionExpired": "истекло",
    "client.booking.sessionExpiredError": "Сессия записи истекла. Обновите страницу и начните заново.",
    "client.booking.nameRequired": "Пожалуйста, укажите имя.",
    "client.booking.footerThanks": "Спасибо за запись.",
    "client.booking.step.services.title": "Выберите услугу",
    "client.booking.step.time.title": "Выберите дату и время",
    "client.booking.durationMinutes": "{{count}} мин",
    "client.booking.anySpecialist": "Любой специалист",
    "client.booking.noSlots": "Нет свободного времени",
    "client.booking.noSlotsHint": "Попробуйте другой день или вступите в лист ожидания.",
    "client.waitlist.successTitle": "Вы в листе ожидания",
    "client.waitlist.successHint": "Мы свяжемся с вами, когда появится подходящее время.",
    "client.waitlist.name": "Ваше имя",
    "client.waitlist.phone": "Телефон",
    "client.waitlist.email": "Email (необязательно)",
    "client.waitlist.notes": "Комментарий (необязательно)",
    "client.waitlist.submitting": "Сохраняем...",
    "client.waitlist.join": "Вступить в лист ожидания",
    "client.booking.group.morning": "Утро",
    "client.booking.group.afternoon": "День",
    "client.booking.group.evening": "Вечер",
    "client.booking.today": "Сегодня",
    "client.booking.defaultStaff": "Специалист",
    "client.booking.whyRecommended": "Почему рекомендуется",
    "client.booking.continueWithSlot": "Продолжить с {{service}} в {{time}}",
    "client.booking.withStaff": "с",
    "client.booking.factor.repeatClient": "Подходит постоянному клиенту",
    "client.booking.factor.gapFill": "Заполнение окна",
    "client.booking.factor.loadBalance": "Баланс нагрузки",
    "client.booking.factor.timeOfDay": "Время дня",
    "common.continue": "Продолжить",
    "client.actions.confirmTitle": "Подтверждение записи",
    "client.actions.manageTitle": "Управление записью",
    "client.actions.loading": "Загрузка деталей...",
    "client.actions.defaultClient": "Клиент",
    "client.actions.defaultService": "Услуга",
    "client.actions.withStaff": "с",
    "client.actions.defaultStaff": "мастером",
    "client.actions.tokenAction": "Действие по токену",
    "client.actions.apply": "Применить действие",
    "client.pwa.title": "Установить приложение записи",
    "client.pwa.body": "Добавьте страницу записи на главный экран для быстрого доступа.",
    "client.pwa.install": "Установить",
    "client.pwa.installing": "Устанавливаем...",
    "client.pwa.dismiss": "Не сейчас",
  },
  es: {
    "manager.layout.openNavigation": "Abrir navegación",
    "manager.dashboard.kpi.waitlistOpen": "Lista de espera abierta",
    "manager.dashboard.waitlistBooked7d": "Reservas desde lista de espera (7d): {{count}}",
    "manager.dashboard.reco.waitlist.title": "Demanda en lista de espera",
    "manager.dashboard.reco.waitlist.body": "{{count}} cliente(s) esperan un horario.",
    "manager.calendar.waitlist.title": "Lista de espera ({{day}})",
    "manager.calendar.waitlist.count": "{{count}} elemento(s)",
    "manager.calendar.waitlist.status.open": "abierta",
    "manager.calendar.waitlist.status.contacted": "contactado",
    "manager.calendar.waitlist.status.booked": "reservado",
    "manager.calendar.waitlist.status.closed": "cerrada",
    "manager.calendar.waitlist.action.copyLink": "Copiar enlace de reserva",
    "manager.calendar.waitlist.action.contacted": "Marcar contactado",
    "manager.calendar.waitlist.action.close": "Cerrar",
    "manager.calendar.waitlist.empty": "No hay elementos en lista de espera para este día.",
    "manager.calendar.waitlist.copied": "Enlace de reserva copiado.",
    "manager.calendar.tab.today": "Hoy",
    "manager.calendar.tab.day": "Día",
    "manager.calendar.tab.queue": "Cola",
    "manager.calendar.tab.waitlist": "Lista de espera",
    "manager.calendar.queue.title": "Cola (próximos 7 días)",
    "manager.calendar.queue.subtitle": "Acciones pendientes en varios días",
    "manager.calendar.search": "Búsqueda rápida",
    "manager.calendar.searchPlaceholder": "Cliente, teléfono, servicio",
    "manager.calendar.staff": "Personal",
    "manager.calendar.staffAll": "Todo el personal",
    "manager.calendar.refresh": "Actualizar",
    "manager.calendar.autorefresh": "Actualización automática cada 30 s",
    "manager.calendar.moreActions": "Más",
    "manager.calendar.viewDetails": "Ver detalles",
    "manager.calendar.retry": "Reintentar",
    "manager.calendar.copyRequestId": "Copiar ID de solicitud",
    "manager.calendar.confirmPrompt": "?Confirmar esta acci?n?",
    "manager.calendar.reason.note": "Nota opcional",
    "manager.calendar.dialog.close": "Cerrar",
    "manager.calendar.dialog.confirm": "Confirmar",
    "manager.calendar.dialog.processing": "Procesando...",
    "manager.calendar.reschedule.apply": "Aplicar",
    "manager.calendar.reschedule.empty": "No hay horarios disponibles para este día.",
    "manager.calendar.reschedule.slotGone": "El horario ya no está disponible",
    "manager.calendar.detail.title": "Detalle de cita",
    "manager.calendar.detail.close": "Cerrar",
    "manager.calendar.detail.schedule": "Agenda",
    "manager.calendar.detail.service": "Servicio",
    "manager.calendar.detail.staff": "Personal",
    "manager.calendar.detail.branch": "Sucursal",
    "manager.calendar.detail.contact": "Contacto",
    "manager.calendar.detail.noPhone": "Sin teléfono",
    "manager.calendar.detail.notes": "Notas",
    "manager.calendar.detail.timeline": "Cronología",
    "manager.calendar.detail.timelineEmpty": "Todavía no hay eventos.",
    "client.booking.heroTitle": "Reserva tu visita",
    "client.booking.heroSubtitle": "Selecciona tu servicio y horario preferido.",
    "client.booking.galleryAlt": "Galería",
    "client.booking.howItWorks": "Cómo funciona",
    "client.booking.howItWorksBody": "Elige servicio, especialista y confirma tu cita en menos de un minuto.",
    "client.booking.sessionTimer": "Temporizador de reserva",
    "client.booking.sessionLeft": "Quedan {{time}}",
    "client.booking.sessionExpired": "expirado",
    "client.booking.sessionExpiredError": "Tu sesión de reserva expiró. Actualiza y vuelve a empezar.",
    "client.booking.nameRequired": "Ingresa tu nombre.",
    "client.booking.footerThanks": "Gracias por reservar con nosotros.",
    "client.booking.step.services.title": "Elige un servicio",
    "client.booking.step.time.title": "Elige fecha y hora",
    "client.booking.durationMinutes": "{{count}} min",
    "client.booking.anySpecialist": "Cualquier especialista",
    "client.booking.noSlots": "No hay horarios disponibles",
    "client.booking.noSlotsHint": "Prueba otro día o únete a la lista de espera.",
    "client.waitlist.successTitle": "Estás en la lista de espera",
    "client.waitlist.successHint": "Te contactaremos cuando se libere un horario compatible.",
    "client.waitlist.name": "Tu nombre",
    "client.waitlist.phone": "Teléfono",
    "client.waitlist.email": "Email (opcional)",
    "client.waitlist.notes": "Notas (opcional)",
    "client.waitlist.submitting": "Guardando...",
    "client.waitlist.join": "Unirme a la lista de espera",
    "client.booking.group.morning": "Mañana",
    "client.booking.group.afternoon": "Tarde",
    "client.booking.group.evening": "Noche",
    "client.booking.today": "Hoy",
    "client.booking.defaultStaff": "Personal",
    "client.booking.whyRecommended": "Por qué se recomienda",
    "client.booking.continueWithSlot": "Continuar con {{service}} a las {{time}}",
    "client.booking.withStaff": "con",
    "client.booking.factor.repeatClient": "Ajuste para cliente recurrente",
    "client.booking.factor.gapFill": "Relleno de huecos",
    "client.booking.factor.loadBalance": "Balance de carga",
    "client.booking.factor.timeOfDay": "Hora del día",
    "common.continue": "Continuar",
    "client.actions.confirmTitle": "Confirmar cita",
    "client.actions.manageTitle": "Gestionar cita",
    "client.actions.loading": "Cargando detalles...",
    "client.actions.defaultClient": "Cliente",
    "client.actions.defaultService": "Servicio",
    "client.actions.withStaff": "con",
    "client.actions.defaultStaff": "personal",
    "client.actions.tokenAction": "Acción del token",
    "client.actions.apply": "Aplicar acción",
    "client.pwa.title": "Instalar app de reservas",
    "client.pwa.body": "Agrega esta página de reservas a tu pantalla de inicio para volver más rápido.",
    "client.pwa.install": "Instalar",
    "client.pwa.installing": "Instalando...",
    "client.pwa.dismiss": "Ahora no",
  },
} as const;

for (const locale of Object.keys(featureTranslations) as Array<keyof typeof featureTranslations>) {
  i18n.addResourceBundle(locale, "translation", featureTranslations[locale], true, true);
}

for (const locale of Object.keys(SIGNUP_PORTAL_TRANSLATIONS) as Array<keyof typeof SIGNUP_PORTAL_TRANSLATIONS>) {
  i18n.addResourceBundle(locale, "translation", SIGNUP_PORTAL_TRANSLATIONS[locale], true, true);
}

export default i18n;
